// Detect user location

get_user_location()
var current_urlval = window.location.href;
if($("#dietRestrictions").val().trim()!='' ){
  localStorage.setItem('dietary',$("#dietRestrictions").val());

}
$(document).on('click', '#logoutdiv', function() {
  window.location.href="/users/logout"
})


$(function() {
  $('#resturantChampionsbutton').click(function() {
    var url = 'data:application/vnd.ms-excel,' + encodeURIComponent($('#resturantChampions').html())
    location.href = url
    return false
    
  })
});
let user_login = document.getElementById('is-logged-in') && document.getElementById('is-logged-in').value || false;

//show login message if user not logged in, for these filters
   $('#highest_flavour_match, .i_rated, .other_rated').on('click',  function(){
    let filterName = $(this).data('name');

       if (!user_login) {
            Swal.fire({
                title: "Login Required",
                text: "Please log in to filter by " + filterName + ".",
                icon: "info",
                allowOutsideClick: true,
                cancelButtonText: 'Dismiss',
                confirmButtonText: "Ok",
                confirmButtonColor: "#3cb371",
            }).then((result) => {
                if (result.isConfirmed) {
                    let redirect_to = localStorage.url_before_logging_in;
                    window.location.assign(`/users/login?next=` + redirect_to);
                }
            });        
            $("#maxFlavour").prop("disabled",true);
        return false;
       }
       return true;
    });
function initialize() {

    var acInputs = document.getElementsByClassName("autocomplete");

    for (var i = 0; i < acInputs.length; i++) {

        var autocomplete = new google.maps.places.Autocomplete(acInputs[i]);
        autocomplete.inputId = acInputs[i].id;

        google.maps.event.addListener(autocomplete, 'place_changed', function () {
           // document.getElementById("log").innerHTML = 'You used input with id ' + this.inputId;
        });
    }
}

initialize();

$('body').on('click,touchstart', function (e) {

   if ($(e.target).data('toggle') !== 'popover'
        && $(e.target).parents('[data-toggle="popover"]').length === 0
        && $(e.target).parents('.popover.in').length === 0) {
        $('[data-toggle="popover"]').popover('hide');
    }else{
      $('[data-toggle="popover"]').popover('show');
    }
        //popover toggle, or icon in popover toggle, or popover


});
function get_user_location() {
    return $.ajax({
        url: '/user/get-location',
        type: "GET"
    })
        .then((res) => {
            if (res && res.latitude && res.longitude ){
                $("#influencer-lat").val(res.latitude);
                $("#influencer-lng").val(res.longitude);
            }
            __user_location = res
        })
        .always(() => {
            if (!_.size(__user_location)) return IP_location()
        })
}

function IP_location() {
    let ipapi_key = $("#ipapiSecret").val();
    if(ipapi_key && typeof ipapi_key !== "undefined"){
      ipapi_key = ipapi_key.toString()
      return $.ajax('https://ipapi.co/json/?key=' + ipapi_key)
        .then(res => {
            __user_location = res
        })
   }
}

window.__user_coordinate = null;

$("#show-me-how").on('click', function(){
  const $this = $(this);
  $('html, body').animate({ scrollTop: $(`#partener-with-us`).offset().top - 100 }, 800);
})

function saveshareData( data, social_type) {
    let userId  = $('#userId').val();
    data.userId=userId;
    data.media=social_type;
    $.ajax({
        url: '/save-socialshare-data',
        method: 'POST',
        dataType: 'json',
        
         data: data,
        success: function(res){
             console.log("Data Saved")
        },
    });


}

function shareOngooglePlus(url, data, winWidth, winHeight) {
        saveshareData(data,'google')
            const winTop   = (screen.height / 2) - (winHeight / 2);
            const winLeft  = (screen.width / 2) - (winWidth / 2);
            let windowSettings = `top=${winTop},left=${winLeft},toolbar=0,status=0,width=${winWidth},height=${winHeight}`;
            let encoded_url   = encodeURIComponent(url);
            let text_param    = (data.text)? '&text=' + encodeURIComponent(data.text) : "";
            let hashtag_param = (data.hastag)? '&hashtag=' + encodeURIComponent(data.hastag) : "";
            //console.log("url====",url)
            //window.open(`https://plus.google.com/share/?url=${encoded_url}${text_param}${hashtag_param}`, 'sharer', windowSettings);
            window.open(`https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=Your+Subject+here&body=+${encodeURIComponent(url)}+&ui=2&tf=1&pli=1`);
        }
$(document).ready(function(){
    // invite link
    let page_slug = window.location.pathname;
        page_slug = page_slug.toLowerCase()
                    .replace(/ /g,'-')
                    .replace(/[^\w-]+/g,'');

    if(page_slug=="invite-friends"){
      let username = $('body #loginUserName').val();
      let invitedescription=  `PlateRate is a great app to help you find food you love wherever you are!. Click here to be ${username}'s Friend on PlateRate and see their favorite menu items around the world!`;
      $("meta[property='og\\:description']").attr("content", invitedescription);
        //console.log("checkingMeta=====",$("meta[property='og\\:description']").attr("content"));
    }

    //Auto replace url

    let venue_id = $('#venueId').val();
    let venue_slug = $('#venue-slug').val();

    if(current_urlval && _.includes(current_urlval, "#collapseRateOrder")){

      let urlSplited = current_urlval.split('#collapseRateOrder-');
      let orderId = urlSplited[1];
      console.log("redirecting to /rate/order since url contains collapseRateOrder");
      if(check_iOSapp() || check_androidApp()) {
        window.location = `/rate/order/${orderId}?flag=mobile`;

      }else{
        window.location = `/rate/order/${orderId}`;

      }


    } else if(current_urlval && _.includes(current_urlval, "#collapseRestaurantOrder")){
      let hasClass = $( ".rest_btn_container" ).find( ".open-restaurant-orders" )
      if(hasClass && hasClass.length>0){
        $('.open-restaurant-orders').trigger('click');
        window.history.replaceState({}, document.title, window.location.pathname);
        $(document).scrollTop( $("#restaurant-orders").offset().top + 20);
      } else {
        $('.open-restaurant-menu').trigger('click');
        window.history.replaceState({}, document.title, window.location.pathname);
      }
   }
    if(venue_id && venue_slug){
        if(!(current_urlval.indexOf(venue_slug) > 0)){
            current_urlval = current_urlval.replace(venue_id,venue_slug);
            window.history.replaceState({}, "", current_urlval);
        }
    }

    // save referralId to Cookies
    var urlShare = new URL(current_urlval);
    var referralIdParams = urlShare.searchParams.get("share-friend");
    if(referralIdParams){
        Cookies.set('platerate_invitationId',referralIdParams);
        // current_url = current_url.replace('?share-friend='+referralIdParams,'');
        // window.history.replaceState({}, "", current_url);
    }

    // auto change css right icon
    if($('#collapseMyOrder').length >0){

        $('#mobilefooter-new').css("position",'relative !important')
        $('#collapseMyOrder').on('shown.bs.modal', function () {
            // $('.hatsIcon').css('right',$(window).width() - $('.fa-shopping-cart.shopping_card').offset().left -28)
        });
    }
    $(document).on('click', '#headingMyOrder', function() {
        //setTimeout(() => {
            $("#collapseMyOrder").modal({
                backdrop: 'static',
                keyboard: true
            });
            haveBackdrop()
       // }, 1000);
    });


    $(document).on('click', '.openCart', function() {
        let venue_slug = $('#shopping_cart_btn').data('venueid');
        const url = window.location.href.split("/restaurant")[1]
       if(url == undefined){
        window.location.href="/restaurant/"+venue_slug
       }
        //setTimeout(() => {
            $("#collapseMyOrder").modal({
                backdrop: 'static',
                keyboard: true
            });
            haveBackdrop()
       // }, 1000);
    });
//facebook share friend
var segments = current_urlval.split('?fbref=');
//console.log("segments====",segments);
//http://localhost:3003/users/login?fbref=BJqaiOeBQ&fbclid=IwAR1FJjPueRovmJcxXJUwwsRTKDIsKp7Dl5j4Z-tDC3p05HlkniibxUhTxWk

if(segments.length==2){
  let pagename = segments[0].split('/');
  var referrerId = segments[1].split('&');

    if(pagename!=undefined && pagename.length==5 && referrerId !=undefined && referrerId.length && referrerId[0]){
        localStorage.setItem("friendfbRef",referrerId[0]);
    }
}
    let userId  = $('#userId').val();
    if(localStorage.getItem('friendfbRef') !=undefined && localStorage.getItem('friendfbRef') && userId !=undefined && userId){
          let sendData={
             "referId":localStorage.getItem('friendfbRef')
          };
            $.ajax({
                url: '/userfriends/facebookRef',
                method: 'POST',
                dataType: 'json',
                data: sendData,
                success: function(res){
                     if(res.status!=undefined && res.status=="Successful"){
                          localStorage.removeItem('friendfbRef');
                      }
                },
            });
    }
//end
    let getsharing = current_urlval.split("?sharing=");
    if(getsharing && getsharing.length>1){
        let referrer= getsharing[1];
        if(referrer){
            let reqid = referrer.split("&");
            if(reqid.length>1) {
                localStorage.setItem("friendId",reqid[1]);
                let loginPage = 'users/login?next=/'
            console.log("redirecting to login page after sharing..");
                window.location ="/"+loginPage;
            }
        }
    }
    if(localStorage.getItem('friendId') !=undefined && localStorage.getItem('friendId') && userId !=undefined && userId){
        let referfriend = localStorage.getItem('friendId');
        let sendData={
            "referfriend":referfriend
        };
        $.ajax({
            url: '/userfriends/bysharelink',
            method: 'POST',
            dataType: 'json',
            data: sendData,
            success: function(res){
              if(res.status!=undefined && res.status=="Successful"){
                   localStorage.removeItem('friendId');
               }
            },
        })
    }
    let userReferrerId = urlShare.searchParams.get("referrerId");
    let menuItem = urlShare.searchParams.get("menuItem");
   
    if(userReferrerId && typeof userReferrerId != "undefined" ){
        Cookies.set('platerate_invitationId',userReferrerId);
        localStorage.setItem("userReferrerId",userReferrerId);
    }

    if(userReferrerId && !current_urlval.includes("/users/register") && !current_urlval.includes("/users/login") && current_urlval.includes("/restaurant") &&(typeof userId==="undefined" || !userId)){
        let searchParams = urlShare.search;
        let pathName = urlShare.pathname;
        console.log("redirecting to login page after sharing and userreferrer..", pathName, searchParams);
         let userloggedcookie = Cookies.get('newuser');
        if ( typeof(userloggedcookie) === 'undefined' && userloggedcookie!='newuserval'){
            var loginPage = `/users/register?next=${pathName}${searchParams}`;
        }else{
            var loginPage = `/users/login?next=${pathName}${searchParams}`;
        }
        
        window.location =loginPage;
    }

    if(!current_urlval.includes("/restaurant")){
        localStorage.removeItem('page_log');
    }

  if(localStorage.getItem('userReferrerId') !=undefined && localStorage.getItem('userReferrerId') && userId!=undefined && userId){
     let data={
         "referrerId": localStorage.getItem('userReferrerId')
      };
        $.ajax({
            url: '/userfriends/shareMenuitem',
            method: 'POST',
            dataType: 'json',
            data: data,
            success: function(res){
              if(res){
                if((res.status!=undefined && res.status=="Successful") || (res.data && res.data.isExist==true)){
                  localStorage.removeItem('userReferrerId');
                }
               }
            },
        })
  }
});

var _updatePositions = function (position) {
    let newLat = position.coords.latitude;
    let newLon = position.coords.longitude;
    let savedLat = Cookies.get('posLat');
    let savedLon = Cookies.get('posLon');

    if (newLat !== savedLat || newLon !== savedLon) {
      //Save new location to cookie
      Cookies.set('posLat', newLat, {
        path: '/'
      });
      Cookies.set('posLon', newLon, {
        path: '/'
      });
    }
  };
var _errorOnLocation = function(e) {
    return false
};
let showFloatingButtons = false;
// let isCheckShowFloatingButtons = false;

commonGetLocation(_updatePositions, _errorOnLocation);

function commonGetLocation(_updatePositions, _errorOnLocation){
  return _errorOnLocation()
}
function handleClick(cb) {
  if($(cb).is(":checked")){
        $(cb).parent().closest('div').css({"background-color": "#rgba(243, 164, 70, 0.53)"})
        $(cb).parent().find('span').html('Shared')

    }else{
        $(cb).parent().closest('div').css({"background-color": "#C8E2D4"})
        $(cb).parent().find('span').html('Share')

    }
}
function commonupdatePositions (position) {
    let newLat = position.coords.latitude;
    let newLon = position.coords.longitude;
    let savedLat = Cookies.get('posLat');
    let savedLon = Cookies.get('posLon');
    if (newLat !== savedLat || newLon !== savedLon) {
      //Save new location to cookie
      Cookies.set('posLat', newLat, {
        path: '/'
      });
      Cookies.set('posLon', newLon, {
        path: '/'
      });
      Cookies.set('locationPermission', 'granted', {
        path: '/'
      });
    }
};
function render_list_friends(data){
    let html = `<div class="row pl-md-4 pr-md-4">`
    _.forEach(data, item => {
        let user_name = item.user.profile.contactInfo;
        let email_friend = item.user.local;
        let urlAvatar = item.user && item.user.profile ? item.user.profile.imageUrl : '';
        if (!urlAvatar) urlAvatar = '/images/avatar.png'
        html += `
            <div class="col-md-6 col-12 pb-4 pr-md-4 item-list-friend">
                <div class="imagefriendlist row   ">
                   <div class="col-2 col-md-2 mt-3">
                        <div class="imagefriend"><img class="imagefriend" src="${urlAvatar}" /></div>
                    </div>
                    <div class="col-6 col-md-6">
                        <div class="mt-4 ml-4 ml-md-3 firstlastname">
                            ${user_name.firstName} ${(user_name.lastName).substring(0, 1).toUpperCase()}
                        </div>
                    </div>

                    <div class="col-4 col-md-4 pt-4">
                        <div class="custom-control custom-checkbox sharedbutton" >
                        <label>
                            <input onclick='handleClick(this);' type="checkbox" class="custom-control-input share-to-user" id="${ item.user._id.toString()}" data-user-id="${item.user._id.toString()}">
                           <span> Share</span>
                       </label>
                       </div>
                    </div>
                </div>
            </div>
        `
    })
    html += `</div>`;
    return html
}

window.shareOnPlaterate = ()=> {
    $("#modal-to-show-sharing-review").hide();
    let userid  = $('#userId').val();
    if(user_login){
        $.ajax({
            url: '/userfriends/friends/',
            method: 'GET',
            contentType: 'application/json; charset=utf-8',
            success: function (result) {
                let listFriends = [];
                _.forEach(result.friends, item => {
                    let hasItem = listFriends.find(element => element.userId === item.userId);
                    if(!hasItem && item.userId != userid){
                        listFriends.push(item);
                    }
                });
                if(listFriends.length > 0){
                    let html = `
                    <ul class="list-group list-group-flush">
                            ${render_list_friends(listFriends)}
                    </ul>`
                    $('#modal-share-to-my-friends').find('#list-my-friends').html(html)
                    $("#modal-share-to-my-friends").iziModal('open')
                }else{
                    render_modal_no_friend();
                    $("#modal-invite-friends").iziModal('open')
                }
                return true;
            },
        });

    }else{
        Swal.fire({
            title: "Login Required",
            text: "Please login to continue.",
            icon: "info",
            allowOutsideClick: true,
            confirmButtonText: "Login or Register",
            confirmButtonColor: "#3cb371"
          }).then((result) => {
            if (result.isConfirmed) {
              let urllogin = '/users/login';
              if (window.location.pathname && (window.location.pathname !== urllogin && window.location.pathname !== '/')) {
                urllogin = `${urllogin}?next=${window.location.pathname}${window.location.search}`;
              }
              window.location.assign(urllogin);
            }
          });
          
          return false;
    }
}
function render_modal_no_friend(){
    if($('#show-modal-no-friend').length){
        $('#modal-restaurent-friend').modal('show');
    }else{

        $('body').append(`<div id="show-modal-no-friend"></div>`);

        let html = `
        <div id="modal-restaurent-friend" class="modal background-blur fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header" style="border-bottom: 0px;">
                    <button class="close" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true" data-dismiss="modal"></i></button>
                </div>
                <div class="modal-body">
                    <img class="centerBlock" src="/images/No_friends.png"><div class="mt-4" style="text-align: center;">
                    <h2>PlateRate is Better with Friends! </h2>
                    <p>You don’t have friends on PlateRate, yet</p>
                </div>
                <div class="centerBlock mt-4 mb-5" style="display: table;">
                    <button class="btn mr-2" data-dismiss="modal" style="color: #28a745;border: 1px solid #28a745;background-color: white;">Maybe Later</button>
                    <button class="btn btn-success ml-2 goto-invite-friends">Invite Friends</button>
                </div>
            </div>
            </div>
        </div>
        `;

        $('#show-modal-no-friend').html(html);
        $('#modal-restaurent-friend').modal('show');
        $('.goto-invite-friends').click(()=>{
            window.location = `/invite-friends`;
        })
    }
}


 function _updateLocationCommonPlaceholder(locationStatus,locationContainer,inputId) {
    let tmp = $('#'+inputId).val() || "";
    if( $(locationStatus).find('#locationinput') && $(locationStatus).find('#locationinput').val() != "") return;
    switch (locationStatus) {
        case "loading":
            locationContainer.html('<input id="${inputId}" name="locationinput" type="text" class="form-control" placeholder="&#xf041; Loading..." />');
            break;
        case "detected":
            if($('.alert-dismissable').length) $('.alert-dismissable').remove();
            locationContainer.html(`<input id="${inputId}" name="locationinput" type="text" class="form-control" placeholder="&#xf041; Current location detected" value="${tmp}" />`);
            break;
        case "denied":
            locationContainer.html('<input id="${inputId}" name="locationinput" type="text" class="form-control " placeholder="&#xf041; Location detection disabled. Please enter" />');
            break;
        case "error":
            locationContainer.html('<input id="${inputId}" name="locationinput" type="text" class="form-control" placeholder="&#xf041; Unable to retrieve your location. Enter location" />');
            break;
        case "ipLocation":
            locationContainer.html('<input id="${inputId}" name="locationinput" type="text" class="form-control search-input" placeholder="&#xf041; Current location approximated" />');
            break;
        case "ipLocation":
            locationContainer.html('<input id="locationinput" name="locationinput" type="text" class="form-control search-input" placeholder="&#xf041; Current location approximated" />');
            break;
        default:
    }
};

var ipLookUp = function(error, selector, _updateLocationPlaceholder, _updatePositions) {
    const setgeopip = function(latitude, longitude) {
      if (latitude && longitude) {
          _updateLocationPlaceholder("ipLocation");
          let position = { coords: { latitude: latitude, longitude: longitude }, fromIp: true };
          _updatePositions(position);
          Cookies.set('showLocationDenied', false, { path: '/' });
      }
    }

    const ipaip = function() {
      let ipapi_key = $("#ipapiSecret").val();
      if(ipapi_key && typeof ipapi_key !== "undefined"){
        ipapi_key = ipapi_key.toString()
        $.ajax('https://ipapi.co/json/?key=' + ipapi_key)
            .then(
                function success(response) {
                    setgeopip(response.latitude, response.longitude);
                },
                function fail(data, status) {
                    if (data.responseJSON.reason == "RateLimited") return false
                    _updateLocationPlaceholder('denied');
                    // if (!(Cookies.get('showLocationDenied'))) {
                    //     swal({
                    //         title: "Unable to detect your location!",
                    //         html: true,
                    //         text: `You have turned off location detection, we will do our best to detect your approximate location using your internet connection location, but we recommend you turn on location detection for improved accuracy.<br>
                    //         To help us serve better, Please<br>
                    //         1. Turn on your device location.<br>
                    //         2. Give 'Platerate' access to your location.<br>
                    //         <br>
                    //         <a href="https://docs.google.com/document/d/1qYini1Ye-LlOFmxZxabKyY8sEmbO6HrJ8WnhMggM9RM/edit#" target="_blank" style="font-style: italic;">How to turn on location detection ?</a>
                    //         `,
                    //         type: "error",
                    //         showCancelButton: true,
                    //         confirmButtonText: "Ok",
                    //         confirmButtonColor: "#3cb371",
                    //         cancelButtonText: "Don't show again",
                    //         closeOnCancel: false
                    //     }, function(disableMessage) {
                    //         if (!disableMessage) {
                    //             Cookies.set('showLocationDenied', false, { path: '/' });
                    //             swal.close();
                    //         }
                    //     });
                    // }
                }
            );
        }
    }
    //Find address by ip access
    $.ajax('/geoip/address').then((res) => {
        if (res && res.ll.length) {
            setgeopip(res.ll[0], res.ll[1]);
        } else {
           ipaip(error)
        }
    })
}

//search input autocomplete
let ITEM_INPUT = $(".headersearch-input"); //this class must exist in the result and search pages
if(ITEM_INPUT) ITEM_INPUT.autocomplete(
{
  source: function(req,res){
    let lat = $('#lat').val();
    let lng = $('#lng').val();

    let locationinput = $("#head-location-input-search").val();
    $.get("/search/suggest?q=" + req["term"] + "&radius="+$('#headerradius-val').val()+"&lat="+lat+"&lng="+lng+"&locationinput="+locationinput,function(data){

        res(JSON.parse(data));
    });
  },
  select: function (event, ui) {
    $("#search").val(ui.item.value)
    commonajaxcallforhome("search");

  }
});
 //Reseting search field
  $('.reset-btn').on('click', function(e) {
      ITEM_INPUT.val("");
  });

var NotificationCtrl = undefined;
var __geocoder;
const isMobile = ( /android|webos|iphone|ipod|blackBerry|iemobile|opera Mini/i.test(navigator.userAgent.toLowerCase()) );

//

let redirect_to = localStorage.url_before_logging_in;
let firstLoadOrder = true;

 let urlOrderBeforeLogin = localStorage.getItem('urlOrderBeforeLogin');
 let orderedBeforeLogin = localStorage.getItem('orderedBeforeLogin');
 console.log("current_urlval,user_login====",current_urlval,user_login);
 console.log("orderedBeforeLogin,urlOrderBeforeLogin====",orderedBeforeLogin,urlOrderBeforeLogin)
 if(user_login && orderedBeforeLogin && urlOrderBeforeLogin
    &&  !redirect_to.includes(current_urlval)
    && !urlOrderBeforeLogin.includes(current_urlval) //do not reload same url; the urlOrderBeforeLogin may have params for buyitemmenuid etc, hence includes
    ){
    if(urlOrderBeforeLogin || ( urlOrderBeforeLogin.includes('type=favorites') && urlOrderBeforeLogin.includes('buymenuitemid'))){
        console.log("####redirect after profile saved")
        
        if(localStorage.getItem('saveProfileRedirect')){
            console.log("###redirect to addcart")
             if(!window.location.href.includes("buymenuitemid")){
                window.location.href = urlOrderBeforeLogin;
            }
            localStorage.removeItem('saveProfileRedirect');
        }
    }
    else{
    console.log("come for redirect ")
   // localStorage.removeItem('orderedBeforeLogin');
    localStorage.removeItem('urlOrderBeforeLogin');
    window.stop();
    console.log("REDIRECTING from app.js...userlogged in redirect to urlOrderBeforeLogin from current_url.and redirect_to is and orderedBeforeLogin is...",urlOrderBeforeLogin, current_urlval, redirect_to, orderedBeforeLogin);
    window.location.href = urlOrderBeforeLogin;
    }
 }
 if(user_login && urlOrderBeforeLogin && (current_urlval.includes(urlOrderBeforeLogin) || urlOrderBeforeLogin.includes(current_urlval))){

    localStorage.removeItem('urlOrderBeforeLogin');
 }
 let setPhoneFirstOrder = localStorage.getItem("setPhoneFirstOrder")
 if(user_login && setPhoneFirstOrder && !window.location.href.includes("?tab=collapseTasterPhone")){
    console.log("redirect after save====000==+++++")
    localStorage.removeItem("setPhoneFirstOrder")
    if(setPhoneFirstOrder.includes("buymenuitemid")){
    console.log("redirect includes buymenuitem====000==+++++")
        const newredirect = setPhoneFirstOrder.split('?')[0];
        window.location.href = newredirect
    }
    else window.location.href = setPhoneFirstOrder
 }
 //hack this happens esp after logging in by fb
let completeUrl = window.location.href
if(completeUrl && completeUrl.endsWith("#_=_")){ //
    const getDataRegisterFb = localStorage.getItem('dataRegisterFB');
    console.log("getDataRegisterFb====", getDataRegisterFb)
    if(getDataRegisterFb == 'loginFB') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'user-signin-success',
          eventProps: {
            category: 'account',
            action: 'user-signin-success',
            label:  'facebook', // put here the platform chosen by the user
            value: 1
          }
        });
    }
    else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'user-signup-success',
          eventProps: {
            category: 'account',
            action: 'user-signup-success',
            label:  'facebook', // put here the platform chosen by the user
            value: 1
          }
        });
    }
    console.log("REDIRECTING from app.js...and removing the _=_ at the nd", completeUrl);
   completeUrl = completeUrl.replace("#_=_","");
    window.location.href = completeUrl;
}

 //hack this happens esp after logging in by google
 let completeUrlAfterGoogleRedirect = window.location.href
 if(completeUrlAfterGoogleRedirect && completeUrlAfterGoogleRedirect.endsWith("#_#_")){ //
     const getDataRegisterGoogle = localStorage.getItem('dataRegisterGoogle');
     console.log("getDataRegisterGoogle====", getDataRegisterGoogle)
     if(getDataRegisterGoogle == 'loginGoogle') {
         window.dataLayer = window.dataLayer || [];
         window.dataLayer.push({
           event: 'user-signin-success',
           eventProps: {
             category: 'account',
             action: 'user-signin-success',
             label:  'google', // put here the platform chosen by the user
             value: 1
           }
         });
     }
     else {
         window.dataLayer = window.dataLayer || [];
         window.dataLayer.push({
           event: 'user-signup-success',
           eventProps: {
             category: 'account',
             action: 'user-signup-success',
             label:  'google', // put here the platform chosen by the user
             value: 1
           }
         });
     }
     console.log("REDIRECTING from app.js...and removing the _#_ at the nd", completeUrlAfterGoogleRedirect);
     completeUrlAfterGoogleRedirect = completeUrlAfterGoogleRedirect.replace("#_#_","");
     window.location.href = completeUrlAfterGoogleRedirect;
 }

  //hack this happens esp after logging in by EmailPhone
  let completeUrlAfterEmailRedirect = window.location.href
  if(completeUrlAfterEmailRedirect && completeUrlAfterEmailRedirect.endsWith("#_##")){ //
      const getDataRegisterEmailPhone = sessionStorage.getItem('email');
      if(getDataRegisterEmailPhone.includes('@')) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'user-signin-success',
            eventProps: {
              category: 'account',
              action: 'user-signin-success',
              label:  'email',
              value: 1
            }
          });
      }
      else {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'user-signin-success',
            eventProps: {
              category: 'account',
              action: 'user-signin-success',
              label:  'contact number', // put here the platform chosen by the user
              value: 1
            }
          });
      }
      console.log("REDIRECTING from app.js...and removing the #_## at the nd", completeUrlAfterEmailRedirect);
      completeUrlAfterEmailRedirect = completeUrlAfterEmailRedirect.replace("#_##","");
      window.location.href = completeUrlAfterEmailRedirect;
  }
  if (completeUrl && completeUrl.endsWith("#")) {
    window.location.href = completeUrl.replace('#', '');
  }
$(document).ready(function() {

    if(current_urlval.includes('openChangeStaff')){
        if(!$('#restaurant-about').is(':visible')){
            $(`.open-restaurant-about`).trigger('click');
        }
        $('#restaurant-about').show('fadeIn')
        $(`#restaurantAdmin`).collapse('show');
        $(`#changing_staff`).collapse('show');
        if(current_urlval.includes('restaurantadmin'))
            $('html, body').animate({ scrollTop: $(`#listRestaurantAdmins`).offset().top - 100}, 1000);
        if(current_urlval.includes('waitstaff'))
            $('html, body').animate({ scrollTop: $(`#list-servers-staff`).offset().top - 100}, 1000);
        if(current_urlval.includes('delivery_staff'))
            $('html, body').animate({ scrollTop: $(`#list-delivery-staff`).offset().top - 100}, 1000);
        if(current_urlval.includes('greeter'))
            $('html, body').animate({ scrollTop: $(`#list-of-greeters`).offset().top - 100}, 1000);
    }
});

$(function () {
//set this if not reset password page
    if(window.location.href.indexOf("/password/") == -1 ) {
      localStorage.setItem('url_before_logging_in',window.location.pathname);
    }
//dont show my order button on restaurant or rate pages

    sessionStorage.setItem("showCheckOut", false);
    $('.searchable label').hide();

	//if login clicked from search friends and influencers tab on homepage
	let tab = localStorage.getItem('headingFriendsReviews');
	if(tab == "true"){
		let userid  = $('#userId').val();
		if(userid){
					setTimeout(function(){
						openNav();
						$("#headingMyPlaterate a").click();
						$("#headingFriendsReviews a").click();
						localStorage.removeItem('headingFriendsReviews');
					}, 500);
		}
	}


    jQuery(document).ready(function ($) {
       
        $('.flat-slider').bootstrapSlider({
            min: 0,
            max: 100,
            tooltip: 'false',
            values: [40, 60],
            formatter: function (value) {
                return;
            }
        });
        $('.range-slider').bootstrapSlider({
            min: 0,
            max: 100,
            range: true,
            values: [40, 60]
        });
        // manage all ajax requests
        $.xhrPool = [];
        $.ajaxSetup({
            beforeSend: function(jqXHR) {
                $.xhrPool.push(jqXHR);
            },
            complete: function(jqXHR) {
                let index = $.xhrPool.indexOf(jqXHR);
                if (index > -1) {
                    $.xhrPool.splice(index, 1);
                }
            }
        });
        $.xhrPool.abortAll = function() {
            $(this).each(function(idx, jqXHR) {
                jqXHR.abort();
            });
            $.xhrPool.length = 0
        };

        $('.custom-slider').bootstrapSlider({
            tooltip: 'hide',
            selection: 'none',
            formatter: function (value) {
                return;
            }
        });

        $('.range-slider-custom').bootstrapSlider({
            min: 0,
            max: 100,
            handle: 'none',
            range: true,
            enabled: false,
            values: [40, 60]
        });
        $(document).ready(function() {
          //set fa icons for bootstrap datetimepicker
          $('.bootstrap-datepicker').datetimepicker({
              format: 'L'
          });
          $('.bootstrap-timepicker').datetimepicker({
              format: 'LT',
              stepping:15
          });
          $("#datepicker").datetimepicker({
            format: 'L'
          });
          $("#from-datepicker").datetimepicker({
              format: 'L'
          });
          $("#to-datepicker").datetimepicker({
              format: 'L'
          });
        });
        //Navigation Handlers
        $('.logout-btn').click(function(e) {
            e.preventDefault();
            $.xhrPool.abortAll();
            $.post('/users/logout', function() {
                $('.header-loggedin').hide();
                //Reload page to update view
                document.location.replace('/users/login');
            });
        });

        //////////////////////////////////////////////////////////////
        /* Start of handling sliders and checkboxes on profile page */
        //////////////////////////////////////////////////////////////
        const $sensoryExpNaBtns = $(".sensory-exp-na-btn");
        // Handle clicks on Sensory Experience  N/A Checkboxes
        $.each($sensoryExpNaBtns, function() {
            const $parentContainer = $(this).parent().parent().parent();
            const $rangeSlider = $parentContainer.find('.range-slider');
            const sliderValue = $rangeSlider.bootstrapSlider('getValue');

            if(sliderValue[0] === 0 && sliderValue[1] === 100) {
                $(this).prop('checked', true);
                $rangeSlider.bootstrapSlider('disable');
            }
        });
        // Handle clicks on Sensory Experience  N/A Checkboxes
        $sensoryExpNaBtns.click(function () {
            let $parentContainer = $(this).parents('.flavors-slider-container');
            let $rangeSlider = $parentContainer.find('.range-slider').bootstrapSlider();
            let parentContainerId = $parentContainer.attr('id');

            // Check if the N/A button is checked
            if ($(this).is(':checked')) {
                $(this).data('prevValue', $rangeSlider.bootstrapSlider('getValue'))
                $(parentContainerId.concat(' .slider-handle')).hide();
                $(parentContainerId.concat(' .slider-selection')).hide();
                $rangeSlider.bootstrapSlider('disable');
                $rangeSlider.bootstrapSlider('setValue', [0,100]);
            } else {
                const value = $(this).data('prevValue');
                $(parentContainerId.concat(' .slider-handle')).show();
                $(parentContainerId.concat(' .slider-selection')).show();
                $rangeSlider.bootstrapSlider('enable');
                $rangeSlider.bootstrapSlider('setValue', value || [40,60]);
            }
        });

        ////////////////////////////////////////////////////////////
        /* End of handling sliders and checkboxes on profile page */
        ////////////////////////////////////////////////////////////
        const preUrl = document.referrer;
        if(current_urlval.includes('/users/healthy-eating-profile') && preUrl.includes('/users/password/set/')) {
          $('.sensory-naright-text').css({
            'padding-left': '90px',
            'display': 'block',
          })
        }
        /**
         * function to set all range of sensory experience page
         */
        $(".sensory-full-range").click(function (){
            $('#sensory-experience input[type="checkbox"]').each(function(i,item){
              $(item).click();
            });
        });

        /////////////////////////////////////////////////////////////
        /*          Menu Item details handlers                     */
        /////////////////////////////////////////////////////////////

        $('.rate-item').on('click', function(e) {
            e.preventDefault();
            //Temporary handler: find the ratings Button to submit item rating
            //to follow current rating logic.
            document.getElementById('rateItemsBtn').click();
        });

        /////////////////////////////////////////////////////////////
        /*         END  Menu Item details handlers                 */
        /////////////////////////////////////////////////////////////

        // TODO: Verify below event handlers and remove if not required

        $("select").change(function () {

            $("select option:selected").each(function () {
            });
        })

        // $('#datepicker').datetimepicker({
        //     stepping:15
        // });



        $('#available-byob').click(function (e) {
            let clickedItem = e.target.id;
            let div = $('#' + clickedItem)
            div.timepicker({
                hourGrid: 4,
                minuteGrid: 10,
                timeFormat: 'hh:mm tt'
            });
        });

        $('.day').click(function (e) {
            let clickedItem = e.target.innerHTML;
            let div = $('.' + clickedItem);
            div.toggleClass('highlight');

        });

        $('#filter').keyup(function () {
            let value = $('#filter').val();
            if (value) {
                let rex = new RegExp($(this).val(), 'i');
                $('.searchable label').hide();
                $('.searchable label').filter(function () {
                    return rex.test($(this).text());
                }).show();

            } else {
                $('.searchable label').hide();
            }
        });

        $('#options').click(function () {
            $('.searchable label').toggle();
        });


        $('.searchable .dietary input:checkbox').change(
            function () {

                if ($(this).is(':checked')) {
                    let p = $('<p>');
                    let checkedValue = $(this).val();
                    p.attr('data-value', checkedValue);
                    p.append(checkedValue);
                    $('#preference').append(p);
                }
            });

    });

    $('#add-value').on('click', function () {
        $('#add-here').empty();
        $('#add-here').toggle();


        let inputBox = '<input type="text" class="form-control materail_input" id="add-input" placeholder="enter value">';
        $('#add-here').append(inputBox);
        let button = '<button id="add">Add</button>';
        $('#add-here').append(button);
        // let mainDiv = $('.searchable');
        // mainDiv.append(label);
    });

    $(document).on('click', '#add', function (e) {
        let value = $('#add-input').val();
        let mainDiv = $('.searchable');
        let label = $('<label>');
        label.attr('class', 'checkbox');
        label.addClass('dietary');
        // label.css('display', 'block');
        let addInput = $('<input>');
        addInput.attr('type', 'checkbox');
        addInput.text(value);
        label.append(addInput);
        mainDiv.append(label);
    });

    $('#save').on('click', function () {
        let itemPrice = $('#price').val();
        let editButton = $('<button>');
        let span = $('<span>');
        let div = $('#price-area');
        let textbox = $('#price');
        let price = $('<div>');
        span.addClass('glyphicon glyphicon-pencil');
        span.attr('id', 'edit');
        editButton.addClass('edit');
        editButton.css('color', '#5D9D36');
        editButton.append(span);
        price.addClass('edited');
        price.html(itemPrice);
        div.append(price);
        div.append(editButton);
        textbox.hide();
        $('#save').hide();
    });

    $(document).on('click', '#edit', function (e) {
        $('#price').show();
        $('#save').show();
        $('.edited').remove();
        $('.edit').remove();
        e.preventDefault();
    });

    let beforeCheck = {
        byEmail: $.trim($('#byEmail-value').val()) == 'true' ? true : false,
        bySms: $.trim($('#bySms-value').val()) == 'true' ? true : false,
        byPostalMail: $.trim($('#byPostalMail-value').val()) == 'true' ? true : false,
    };

    $( "#never").change(function() {
        if( $('#never').prop('checked')){

            beforeCheck = {
                byEmail: $('#byEmail').prop('checked'),
                bySms: $('#bySms').prop('checked'),
                byPostalMail: $('#byPostalMail').prop('checked')
            };

            $("#byEmail").prop('checked', false);
            $('#byEmail').attr('value', false);

            $("#bySms").prop('checked', false);
            $('#bySms').attr('value', false);

            $("#byPostalMail").prop('checked', false);
            $('#byPostalMail').attr('value', false);

            $('#never').attr('value', true);
        } else {
            $("#byEmail").prop('checked', beforeCheck.byEmail);
            $('#byEmail').attr('value', beforeCheck.byEmail);

            $("#bySms").prop('checked', beforeCheck.bySms);
            $('#bySms').attr('value', beforeCheck.bySms);

            $("#byPostalMail").prop('checked', beforeCheck.byPostalMail);
            $('#byPostalMail').attr('value', beforeCheck.byPostalMail);

            $('#never').attr('value', false);
        }
    });

    $( "#byEmail").parent('label')
        .click(function() {
            if( $('#byEmail').prop('checked')){
                $('#byEmail').attr('value', true);

                $("#never").prop('checked', false);
                $('#never').attr('value', false);
            } else if($('#bySms').prop('checked')) {
                $('#byEmail').attr('value', false);

                $('#bySms').attr('value', true);
            } else if($('#byPostalMail').prop('checked')) {
                $('#byEmail').attr('value', false);

                $('#byPostalMail').attr('value', true);
            } else {
                $('#byEmail').attr('value', false);

                $("#never").prop('checked', true);
                $('#never').attr('value', true);
            }
        });

    $( "#bySms" ).parent('label')
        .click(function() {

            if( $('#bySms').prop('checked')){
                $('#bySms').attr('value', true);

                $("#never").prop('checked', false);
                $('#never').attr('value', false);
            } else if($('#byEmail').prop('checked')) {
                $('#bySms').attr('value', false);

                $('#byEmail').attr('value', true);
            }
            else if($('#byPostalMail').prop('checked')) {
                $('#bySms').attr('value', false);

                $('#byPostalMail').attr('value', true);
            } else {
                $('#bySms').attr('value', false);

                $("#never").prop('checked', true);
                $('#never').attr('value', true);
            }

        });

    $("#byPostalMail").parent('label')
        .click(function() {
            if( $('#byPostalMail').prop('checked')){
                $('#byPostalMail').attr('value', true);

                $("#never").prop('checked', false);
                $('#never').attr('value', false);
            } else if($('#byEmail').prop('checked')) {
                $('#byPostalMail').attr('value', false);

                $('#byEmail').prop('checked', true)
                $('#byEmail').attr('value', true);
            } else if($('#bySms').prop('checked')) {
                $('#byPostalMail').attr('value', false);

                $('#bySms').prop('checked', true)
                $('#bySms').attr('value', true);
            } else {
                $('#byPostalMail').attr('value', false);

                $("#never").prop('checked', true);
                $('#never').attr('value', true);
            }

        });
        // I oumou my code ended here


        // Social media Sharing
        window.shareOntext = (url, data, winWidth, winHeight) => {
            const winTop = (screen.height / 2) - (winHeight / 2);
            const winLeft = (screen.width / 2) - (winWidth / 2);
            let windowSettings = `top=${winTop},left=${winLeft},toolbar=0,status=0,width=${winWidth},height=${winHeight}`;

            $.ajax({
                url: '/userfriends/socialShare',
                method: 'POST',
                dataType: 'json',
                data: url,
                success: function(res){
                    if(res.status=="Successful" && res.data._id!=undefined && res.data._id){


                   }
                },

           })
        }

        window.shareOnFacebook = (url, data, winWidth, winHeight) => {
            const winTop = (screen.height / 2) - (winHeight / 2);
            const winLeft = (screen.width / 2) - (winWidth / 2);
            let redirect_url = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':'+ window.location.port : ''}/rate/order/${data.orderId}/share`;
            let windowSettings = `top=${winTop},left=${winLeft},toolbar=0,status=0,width=${winWidth},height=${winHeight}`;
            let params = '';
        
            // Check if image URL is available
            if (data.image) {
                params += `&picture=${data.image}`;
            }
        
            const isMobile = (/android|webos|iphone|ipod|blackBerry|iemobile|opera Mini/i.test(navigator.userAgent.toLowerCase()));
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            let sendData = {
                socialShare: "facebook"
            };
        
            $.ajax({
                url: '/userfriends/socialShare',
                method: 'POST',
                dataType: 'json',
                data: sendData,
                success: function (res) {
                    if (res.status == "Successful") {
                        saveshareData(data, 'facebook');
                        data.referralId = res && res.data && res.data.referralId ? res.data.referralId : '';
                        let requestUrl = modifyUrlShare(url, data);
                        let encoded_url = encodeURIComponent(requestUrl);
                        if (isSafari) {
                            window.location.assign(`https://www.facebook.com/sharer.php?u=${encoded_url}${params}`);
                        } else if (isMobile) {
                            $.getScript('//connect.facebook.net/en_US/sdk.js', function () {
                                FB.init({
                                    appId: 1556842837659191,
                                    version: "v2.7",
                                });
                                FB.ui({
                                    method: 'share',
                                    href: data.menuItemId ? `${requestUrl}${params}&menuItemLink=${data.menuItemId}` : `${requestUrl}${params}`,
                                }, function (response) {});
                            });
                        } else {
                           // window.open(`https://www.facebook.com/sharer.php?u=${encoded_url}${params}`, 'sharer', windowSettings);
                           $.getScript('//connect.facebook.net/en_US/sdk.js', function(){
                            FB.init({
                                appId: '1556842837659191', // Your Facebook App ID
                                version: 'v2.7'
                            });
                            
                            // Assuming you have 'data' object containing 'menuItemId', 'requestUrl', 'params', and 'imageURL'
                            var menuItemURL = data.menuItemId ? `${data.requestUrl}&menuItemLink=${data.menuItemId}` : `${data.requestUrl}${data.params}`;
                            
                            FB.ui({
                                method: 'share',
                                href: menuItemURL,
                                picture: data.image // URL of the image associated with the menu item
                            }, function(response){});
                        });
                        }
                    }
                },
            })
        }
        

        window.shareOnTwitter = (url, data, winWidth, winHeight) => {
            const winTop   = (screen.height / 2) - (winHeight / 2);
            const winLeft  = (screen.width / 2) - (winWidth / 2);
            let windowSettings = `top=${winTop},left=${winLeft},toolbar=0,status=0,width=${winWidth},height=${winHeight}`;
            const isMobile = ( /android|webos|iphone|ipod|blackBerry|iemobile|opera Mini/i.test(navigator.userAgent.toLowerCase()) );
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            let sendData = {
                socialShare:"Twitter"
            };
             $.ajax({
                    url: '/userfriends/socialShare',
                    method: 'POST',
                    dataType: 'json',
                    data: sendData,
                    success: function(res){
                        // if(res.status=="Successful" && res.data._id!=undefined && res.data._id){
                        if(res.status=="Successful"){
                            saveshareData(data,'Twitter')
                            data.referralId = res && res.data && res.data.referralId? res.data.referralId :'';
                            let requestUrl = modifyUrlShare(url,data);
                            let encoded_url = encodeURIComponent(requestUrl);
                            let text_param    = (data.text)? '&text=' + encodeURIComponent(data.text) : '';
                            let hashtag_param = (data.hastag)? '&hashtag=' + encodeURIComponent(data.hastag) : '';
                            // window.open(`https://twitter.com/intent/tweet?url=${encoded_url}${text_param}${hashtag_param}`, 'sharer', windowSettings);

                            if(isSafari){
                                window.location.assign(`https://twitter.com/intent/tweet?url=${encoded_url}${text_param}${hashtag_param}`);
                            }else if(isMobile){
                                window.open(`https://twitter.com/intent/tweet?url=${encoded_url}${text_param}${hashtag_param}`, '_blank');
                            }else{
                                window.open(`https://twitter.com/intent/tweet?url=${encoded_url}${text_param}${hashtag_param}`, 'sharer', windowSettings);
                            }
                        }
                    },

           })
        }

        window.shareOnlinkedin = (url, data, winWidth, winHeight) => {
            const winTop   = (screen.height / 2) - (winHeight / 2);
            const winLeft  = (screen.width / 2) - (winWidth / 2);
            let windowSettings = `top=${winTop},left=${winLeft},toolbar=0,status=0,width=${winWidth},height=${winHeight}`;
            const isMobile = ( /android|webos|iphone|ipod|blackBerry|iemobile|opera Mini/i.test(navigator.userAgent.toLowerCase()) );
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            let sendData = {
                socialShare:"linkedin"
            };
            $.ajax({
                    url: '/userfriends/socialShare',
                    method: 'POST',
                    dataType: 'json',
                    data: sendData,
                    success: function(res){
                        // if(res.status=="Successful" && res.data._id!=undefined && res.data._id){
                        if(res.status=="Successful"){
                            saveshareData(data,'linkedin')
                            data.referralId = res && res.data && res.data.referralId? res.data.referralId :'';
                            let requestUrl = modifyUrlShare(url,data);
                            let encoded_url = encodeURIComponent(requestUrl);
                            let text_param    = (data.text)? '&text=' + encodeURIComponent(data.text) : '';
                            let hashtag_param = (data.hastag)? '&hashtag=' + encodeURIComponent(data.hastag) : '';

                            if(isSafari){
                                window.location.assign(`https://www.linkedin.com/shareArticle?mini=true&url=${encoded_url}${text_param}${hashtag_param}`);
                            }else if(isMobile){
                                window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encoded_url}${text_param}${hashtag_param}`, '_blank');
                            }else{
                               window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encoded_url}${text_param}${hashtag_param}`, 'sharer', windowSettings);
                            }
                       }
                    },

           })

        }



        function modifyUrlShare(url,data){
            if(data.referralId){
                url +='?share-friend='+ data.referralId;
            }
            if(data.venueId){
                url +='&venueId='+ data.venueId;
            }
            if(data.menuItemId){
                url +='&menuitem='+ data.menuItemId;
                url +='&menuItemLink='+ data.menuItemId;
            }
            if(data.point){
                url +='&rate='+ data.point;
            }
            return url;
        }

        $("body").on('click', '.facebook-share-button', function (e) {
          const $target = $(this);
          const url     = $target.data('href');
          const data    = {
            image   : $target.data('image'),
            menuItemId   : $target.data('item-id'),
            venueId   : $target.data('venue-id'),
          }

          if(!data.image) data.text = $target.data('text');
          shareOnFacebook(url, data, 520, 350);
        });

        $("body").on('click', '.twitter-share-button,.twitter-share-btn,.twitter-share', function (e) {
          const $target = $(this);
          const url     = $target.data('href');
          const data    = {
            text   : $target.data('text'),
            hastag : $target.data('hastag'),
          }
          shareOnTwitter(url, data, 520, 350);
        });

        $("body").on('click', '.linkedin-share-button', function (e) {
          const $target = $(this);
          const url     = $target.data('href');
          const data    = {
            text   : $target.data('text'),
            hastag : $target.data('hastag'),
          }
          shareOnlinkedin(url, data, 520, 350);
        });




        if (isMobile && navigator.userAgent.toLowerCase().indexOf('firefox')  <= -1 ){ // Not working with FF since its input type="number" removes trailing zero
          $('.auto-decimal-input').unbind();
          $('.auto-decimal-input').bind("cut copy paste drag drop", function(e) {
              e.preventDefault();
          });
          $(".auto-decimal-input").on('change', function (e) {
            $(this).val(parseFloat($(this).val()).toFixed(2));
          })

          $("body").on('keyup', '.auto-decimal-input', function (e) {
            let text = $(this).val();
            text.trim();
            if (isNaN(text)) {
              let oldVal = $(this).data('old-value');
              $(this).val(oldVal);
            } else {
              switch (text) {
                case 1:
                  $(this).val("0.0" + text);
                  break;
                default:
                  let data = text.replace(".", "");
                  let first = data.substring(0, (data.length - 2));
                  let second = data.substring(data.length - 2);
                  let temp = Math.abs(first) + "." + second;

                  $(this).data('old-value', temp);
                  $(this).val(temp);
              }
            }
          });
        }
        $(document).ready(function(){
//to show confirmation message and redirect to order confirmation part
            const urlParams = new URLSearchParams(window.location.search);
            const orderStatus = urlParams.get('orderComplete');
            const orderData=urlParams.get('show');
            if(orderStatus && orderData){
                let orderId=orderData.split("-")[1];

                if(orderStatus){
                    showModelConfirmOrder(orderId);
                 }
            }
            if(!$('#userId').val()) return
            sessionStorage.checking_auth = 'false';
            $( document ).ajaxError( function( event, jqxhr, settings, exception ) {
                if(!sessionStorage.checking_auth || sessionStorage.checking_auth == 'false'){
                    sessionStorage.checking_auth = 'true';
                    $.ajax({
                        url: '/users/checkauth',
                        method: 'GET',
                        dataType: 'json',
                        success: function(s_msg){
                            return sessionStorage.checking_auth = 'false';
                        },
                        error: function(e_msg) {
                            if ( e_msg.status == 401 ) {
                                let active_ele = $('.material_accordion_collapse.collapsing').attr('id');
                                if(!active_ele) active_ele = $('.material_accordion_collapse.in').attr('id');
                                let _show = _.replace(active_ele,'collapse','')
                                let uri = `/users/login?next=${location.pathname}?show=${_show}`;
                                console.log("auth error, hence rdirecting...", uri);
                                window.location.assign(uri)
                            }
                            return
                        }
                    })
                }
            });
        })




      /* Use for Google Tag Manager, tracking events that's not behavioral
        eg. ajax calls, etc
      */
      const PixelEvent = (() => {
        const init_check = () =>{
         // complete_payment()
          complete_profile()
        }


        const complete_order = () =>{
          $("#trkp-complete-order").show(1).delay(1000).hide(1)
        }


       /* const complete_payment = () =>{
        const kochavaorderval = localStorage.getItem("kochavaOrder");
        const userId = localStorage.getItem("kochavaUserId");
        const userName=localStorage.getItem("kochavaUserName");
        const orderTotalAmount= localStorage.getItem("orderTotalAmount");
        const kochavaorder=JSON.parse(kochavaorderval);
         if (kochavaorderval && kochavaorderval!=null){
            $("#trkp-complete-payment").show()
//send info to kochava after payment sucess

		const kocahavauserId=JSON.parse(userId);
		const kocahavauserName=JSON.parse(userName);
		if(kochavaorder){
		  if(check_iOSapp() || check_androidApp()) {
		    window.location = "plateratewebtonative:paypal?orderId="+kochavaorder.orderId+"&price="+orderTotalAmount+"&userId="+kocahavauserId+"&userName="+kocahavauserName+"";
		  }
		  else{
		    if(kochava){
            let odate = moment().format('YYYY/MM/DD');
              var event_and_custom_data = {
              "transaction_id": kochavaorder.orderId,
              "currency": "USD",
              "revenue": orderTotalAmount,
              "now_date": odate,
              "user_id": kocahavauserId,
              "name": kocahavauserName,

            };



		        kochava.activity('Purchase', {
		          now_date: odate,
		          order_id: kochavaorder.orderId,
		          price: orderTotalAmount,
		          user_id: kocahavauserId,
		          name: kocahavauserName,
		        }, function(a, b){
		      });
		    }
		  }
		    localStorage.removeItem('kochavaOrder');
		    localStorage.removeItem('kochavaUserId');
		    localStorage.removeItem('kochavaUserName');
        localStorage.removeItem('kochavaorderval');

		}

          }
        }*/

        const complete_profile = () =>{
          if ($("#flash-event-profile-completed").length){
            $("#trkp-complete-profile").show()
          }
        }

        return {
          init_check,
          complete_order,
         // complete_payment,
          complete_profile
        }
      })();


      PixelEvent.init_check()
      window.PixelEvent= PixelEvent
});

//TODO: //Verify below code
(function($) {

    $.fn.rating = function() {

        let element;

        // A private function to highlight a star corresponding to a given value
        function _paintValue(ratingInput, value) {
            let selectedStar = $(ratingInput).find('[data-value=' + value + ']');
            selectedStar.removeClass('glyphicon-star-empty').addClass('glyphicon-star');
            selectedStar.prevAll('[data-value]').removeClass('glyphicon-star-empty').addClass('glyphicon-star');
            selectedStar.nextAll('[data-value]').removeClass('glyphicon-star').addClass('glyphicon-star-empty');
        }

        // A private function to remove the selected rating
        function _clearValue(ratingInput) {
            let self = $(ratingInput);
            self.find('[data-value]').removeClass('glyphicon-star').addClass('glyphicon-star-empty');
            self.find('.rating-clear').hide();
            self.find('input').val('').trigger('change');
        }

        // Iterate and transform all selected inputs
        for (element = this.length - 1; element >= 0; element--) {

            let el, i, ratingInputs,
                originalInput = $(this[element]),
                max = originalInput.data('max') || 5,
                min = originalInput.data('min') || 0,
                clearable = originalInput.data('clearable') || null,
                stars = '';

            // HTML element construction
            for (i = min; i <= max; i++) {
                // Create <max> empty stars
                stars += ['<span class="glyphicon glyphicon-star-empty" data-value="', i, '"></span>'].join('');
            }
            // Add a clear link if clearable option is set
            if (clearable) {
                stars += [
                    ' <a class="rating-clear" style="display:none;" href="javascript:void">',
                    '<span class="glyphicon glyphicon-remove"></span> ',
                    clearable,
                    '</a>'
                ].join('');
            }

            el = [
                // Rating widget is wrapped inside a div
                '<div class="rating-input">',
                stars,
                // Value will be hold in a hidden input with same name and id than original input so the form will still work
                '<input type="hidden" name="',
                originalInput.attr('name'),
                '" value="',
                originalInput.val(),
                '" id="',
                originalInput.attr('id'),
                '" />',
                '</div>'
            ].join('');

            // Replace original inputs HTML with the new one
            originalInput.replaceWith(el);

        }

        // Give live to the newly generated widgets
        $('.rating-input')
        // Highlight stars on hovering
            .on('mouseenter', '[data-value]', function() {
                let self = $(this);
                _paintValue(self.closest('.rating-input'), self.data('value'));
            })
            // View current value while mouse is out
            .on('mouseleave', '[data-value]', function() {
                let self = $(this);
                let val = self.siblings('input').val();
                if (val) {
                    _paintValue(self.closest('.rating-input'), val);
                } else {
                    _clearValue(self.closest('.rating-input'));
                }
            })
            // Set the selected value to the hidden field
            .on('click', '[data-value]', function(e) {
                let self = $(this);
                let val = self.data('value');
                self.siblings('input').val(val).trigger('change');
                self.siblings('.rating-clear').show();
                e.preventDefault();
                false
            })
            // Remove value on clear
            .on('click', '.rating-clear', function(e) {
                _clearValue($(this).closest('.rating-input'));
                e.preventDefault();
                false
            })
            // Initialize view with default value
            .each(function() {
                let val = $(this).find('input').val();
                if (val) {
                    _paintValue(this, val);
                    $(this).find('.rating-clear').show();
                }
            });

    };

    $.fn.getFormData = function(properties = []){
      let data = {};
      let dataArray = $(this).serializeArray();
      for(let i=0;i<dataArray.length;i++){
        if (properties && properties.length){
          if (properties.includes(dataArray[i].name)) data[dataArray[i].name] = dataArray[i].value;
        } else {
          data[dataArray[i].name] = dataArray[i].value;
        }
      }
      return data;
    }

    $.customTextEditTrigger = function(element, params) {
       let { selector, inputHTML, editHTML, doneHTML, formatter, dataObject, onChange, inputContainer, inEditTitle, showEdit } = params;
       if (!formatter) formatter = _defaultFormatter;
       let $trigger = $(element);
       let $selector = $(selector);
       let $inputContainer =  inputContainer ? $(inputContainer) : $selector;

       let state = 'display';
       //data
       let inputComponents = {};
       let dataObjectKeys = [];

       $trigger.html(editHTML);
       _syncDataToInputComponents();
       _render();
       renderOther();

       //handlers
       $trigger.click(function () {
           if (state === 'display'){
             $trigger.html(doneHTML)
             state = 'edit';
             $selector.html(inEditTitle || '');
             $inputContainer.html('');

             dataObjectKeys.forEach((key, index) => {
               let $input = inputComponents[key];
               $inputContainer.append($input);
               if(index == dataObjectKeys.length-1) {
                 $inputContainer.find('input').focus();
                 $inputContainer.find('input').on('keydown', function (e) {
                   if (e.key === 'Enter' || e.keyCode === 13) {
                     $trigger.trigger('click');
                   }
                 });
               }
             })
             showEdit();
           } else if (state === 'edit'){ // data update and display
             $trigger.html(editHTML);
             state = 'display';

             let _dataChanged = false;
             // map from input to dataset
             dataObjectKeys.forEach(key => {
               if (dataObject[key] !== inputComponents[key].val()) _dataChanged = true;
               dataObject[key] = inputComponents[key].val();
             })

             _render();
             renderOther();
             onChange({...dataObject, _dataChanged});
           }
       });

       this.setData = (data) => {
         state = 'display';
         $trigger.html(editHTML);
         dataObject = Object.assign(dataObject, data)
         _syncDataToInputComponents();
         _render();
         renderOther();
       }

       this.getData = () => {
         return dataObject;
       }

       this.triggerOnChange = (_dataChanged) => {
         // map from input to dataset
         let dataObject = {};
         dataObjectKeys.forEach(key => {
           // if (dataObject[key] !== inputComponents[key].val()) _dataChanged = true;
           dataObject[key] = inputComponents[key].val();
         })
         onChange({...dataObject, _dataChanged});
       }

       function renderOther() {
           if(dataObject && dataObject.apartmentNumber){
                let newText = dataObject.apartmentNumber ? dataObject.apartmentNumber : '';
                $('#delivery-apartment').html(newText);
           }
       }

       function _render() {
         let newText = formatter(dataObject);
         $inputContainer.html('');
         $selector.html(newText);
       }

       function _syncDataToInputComponents(){
         inputComponents = {};
         dataObjectKeys = [...dataObjectKeys, ...Object.keys(dataObject)];
         let _dataChanged = false;
         for (const key in dataObject) {
           inputComponents[key] = $(inputHTML[key]);
           if (dataObject[key] !== inputComponents[key].val()) _dataChanged = true;
           inputComponents[key].val(dataObject[key])
         }
         return _dataChanged;
       }

       function _defaultFormatter(data){
         return Object.values(data).join(', ')
       }

       return this;
    };

    $.fn.customTextEditTrigger = function(params) {
        return this.each(function() {
            if (undefined == $(this).data('customTextEditTrigger')) {
                var plugin = new $.customTextEditTrigger(this, params);
                $(this).data('customTextEditTrigger', plugin);
            }
        });
    }


    // Auto apply conversion of number fields with class 'rating' into rating-fields
    $(function() {
        if ($('input.rating[type=number]').length > 0) {
            $('input.rating[type=number]').rating();
        }
    });
    //tracking search results
    $( '#searchbutton' ).click(function() {
        //to show loading gif
        $(`#serach-loader`).css('display', 'block');
        $('#searchbutton').attr("disabled", true);
        fbq('track', 'Search', {
            search_string: 'searchField'
        });
    });


    const initSocketConnection = () => {
      return new Promise(function(resolve, reject){
        if ( (!NotificationCtrl && NotificationModule ) || !NotificationCtrl.socket.connected) {
          NotificationCtrl = new NotificationModule();
          NotificationCtrl.init();
          resolve('created')
        } else {
          resolve(NotificationCtrl.check_connect())
        }
      });
    }
    window.initSocketConnection = initSocketConnection
    initSocketConnection()


    // attach('https://maps.googleapis.com/maps/api/js?key=AIzaSyA2Sq7QvbkL5Ou4ulgIPw5C0K8rvsq4KRs').then(function (res) {
    //     __geocoder = new google.maps.Geocoder();
    // });

}(jQuery));


function updateNativeAppLocation(lat,long,fromIp){
    let position = {coords:{latitude: lat, longitude: long},fromIp:fromIp};
    $("#nativeAppLatitude").val(lat);
    $("#nativeAppLongitude").val(long);

    // handling for basicsearch-home.js
    if(window.geoLocation && window.geoLocation.updatePositions){
        window.geoLocation.updatePositions(position);
        if(fromIp){
            $(".location-warning").remove();
            $("#mainContainer").prepend('<br><div class="alert alert-warning location-warning">You have turned off location detection, we will do our best to detect your approximate location using your internet connection location, but we recommend you turn on location detection for improved accuracy.' +
                ' To help us serve better, Please <p>1. Turn on your device location.</p> <p>2. Give \'Platerate\' access to your location.</p>' +
                '<br><a href="https://docs.google.com/document/d/1qYini1Ye-LlOFmxZxabKyY8sEmbO6HrJ8WnhMggM9RM/edit#" target="_blank" style="font-style: italic;">How to turn on location detection ?</a>' +
                '</div>');
        }
    }

    //handling for notification.module.js
    if(window.notificationGeoLocation && window.notificationGeoLocation.updatePushPositions){
        window.notificationGeoLocation.updatePushPositions(position);
    }

    //handling for profileFunctions.js
    if(window.profileGeoLocation && window.profileGeoLocation.updatePositions){
        window.profileGeoLocation.updatePositions(position);
        if(fromIp){
            $(".location-error").remove();
            $("#notification_block").prepend('<br><div class="container location-error"><div class="alert alert-warning text-left">You have turned off location detection, we will do our best to detect your approximate location using your internet connection location, but we recommend you turn on location detection for improved accuracy.' +
                        ' To help us serve better, Please <p>1. Turn on your device location.</p> <p>2. Give \'Platerate\' access to your location.</p>' +
                        '<br><a href="https://docs.google.com/document/d/1qYini1Ye-LlOFmxZxabKyY8sEmbO6HrJ8WnhMggM9RM/edit#" target="_blank" style="font-style: italic;">How to turn on location detection ?</a>' +
                        '</div></div>');
        }
    }
    if(typeof _updatePositions == "function"){
        _updatePositions(position);
    }
    //Save new location to cookie
    Cookies.set('posLat', lat, { path: '/'});
    Cookies.set('posLon', long, { path: '/'});
}

/**
 * for mobile apps to update lat long everywhere
 */
function setLocation(hasPermission,lat,long){
    if(hasPermission && lat && long){
        updateNativeAppLocation(lat, long, false)
    } else {
        const ipaip = function() {
          let ipapi_key = $("#ipapiSecret").val();
          if(ipapi_key && typeof ipapi_key !== "undefined"){
            ipapi_key = ipapi_key.toString()
            $.ajax('https://ipapi.co/json/?key='+$(ipapi_key))
              .then(
                function success(response) {
                    if(response.latitude && response.longitude){
                      updateNativeAppLocation(response.latitude,response.longitude,true);
                    }
                }
             );
          }
        }
        //Find address by ip access
        ipaip()
    }
}

function attach(path) {
    return new Promise(function (cb) {
        let el = document.createElement('script');
        el.onload = el.onerror = cb;
        el.src = path;
        document.getElementsByTagName("head")[0].appendChild(el);
    });
};
let numberFormat = function(num, f=2) {
    num = Number(num);
    let _number =  Number.parseFloat(num);
    if(isNaN(_number)) _number = 0;
    return _number.toFixed(f);
}

function check_iOSapp() {
    return (window.navigator.userAgent == 'PlateRateForIOS');
}
function check_androidApp() {
    return (window.navigator.userAgent == 'PlateRateForAndroid');
}

/* pls let vandana know if this function is ever called; doesnot seem like it as of 200701 */
function registerDevice(device_uid, token, device_type, app_version, device_name, device_resolution){
    let pushData = {
        'device_uid':device_uid,
        'token':token,
        'device_type':device_type,
        'app_version':app_version,
        'device_name':device_name,
        'device_resolution':device_resolution
    }

    $.ajax({
        url: '/registerDevice',
        method: 'POST',
        dataType: 'json',
        data: pushData,
        success: function(s_msg){

        },
    })
}



/*
    Generate a random hex id
*/
function createUUID() {
    // http://www.ietf.org/rfc/rfc4122.txt
    let s = [];
    let hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    let uuid = s.join("");
    return uuid;
}



window.haveBackdrop = function () {
    if ($('.modal-backdrop').length > 0) {
        $('.modal-backdrop').addClass('my-ordermodal-backdrop');
        $('body').removeClass('modal-open');

        //commenting to always have mobile footer show up $('#mobilefooter-new').attr("style", "z-index: auto;");
        var modal = document.getElementById('collapseMyOrder');
        $('#collapseMyOrder').css('display', 'block');
        // When the user clicks anywhere outside of the modal, close it

        clearTimeout(mBackdrop);
        return true;
    }
  return false;
}

var mBackdrop;
window.onclick = function(event) {
  var modal = document.getElementById('collapseMyOrder');
  if (event.target == modal) {
      $('#collapseMyOrder').hide()
    //   $('.order-this-item').focus();
  }
}
// Checkout My Order
//setTimeout(() => {

    // $("#collapseMyOrder").modal({
    //     backdrop: 'static',
    //     keyboard: true
    // });
    haveBackdrop()

//}, 1000);

$('body').append(`
    <div class="show-modal-all-orders"></div>
    <div class="show-modal-restaurant"></div>
`);
$.fn.isInViewport = function (_type) {
    try {
        if (!$(this).offset()) return;
        let elementLeft = $(this).offset().left;
        let elementRight = elementLeft + $(this).outerWidth();

        let elementTop = $(this).offset().top;
        let elementBottom = elementTop + $(this).outerHeight();

        let viewportLeft = $(window).scrollLeft();
        let viewportRight = viewportLeft + $(window).width();

        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();

        switch (_type) {
            case 'horizontal':
                return (elementBottom > viewportTop && elementTop < viewportBottom)
                break;
            case 'vertical':
                return (elementRight > viewportLeft && elementLeft < viewportRight)
                break;
            default:
                return (elementRight > viewportLeft && elementLeft < viewportRight && elementBottom > viewportTop && elementTop < viewportBottom)
                break;
        }
    } catch (e) {
        console.error(e);
        return false;
    }
  };
$(window).on('scroll', function(){
    if ($('footer').isInViewport()) {
      $('.float-action-buttons').css({'bottom': '10%'});
    } else {
      $('.float-action-buttons').css({'bottom': '5%'});
    }
});
$(document).ready(function(){
    let cUrl = window.location.href;
    const scroll_order_restaurant = sessionStorage.getItem(`scroll_order_restaurant`);
    const scroll_additional_restaurant = sessionStorage.getItem(`additionalRestaurant`);
    if(_.includes(cUrl, 'restaurant')) __checkout_load.render_checkout = false;
    if(scroll_order_restaurant && $(`#accordionRestaurantOrderButton`).offset())
    {
        //setTimeout(function(){
            $('html, body').animate({ scrollTop: $(`#accordionRestaurantOrderButton`).offset().top }, 1000);
            $(`#accordionRestaurantOrderButton`).click();
            sessionStorage.removeItem('scroll_order_restaurant');
       // }, 1000);
    }
    if(scroll_additional_restaurant)
    {
        if($('.additional-accordion').length >0){
            window.onload = function(){
                $(`#accordionRestaurant`).click();
                $('.additional-accordion').click();
                if(scroll_additional_restaurant != '' && $('[data-trackey="'+scroll_additional_restaurant+'"]').offset()){
                    $('[data-trackey="'+scroll_additional_restaurant+'"]').click();
                    $('html, body').animate({ scrollTop: $('[data-trackey="'+scroll_additional_restaurant+'"]').offset().top }, 1000);
                    sessionStorage.removeItem('additionalRestaurant');
                }else if ($(`.additional-accordion`).offset()){
                    $('html, body').animate({ scrollTop: $(`.additional-accordion`).offset().top }, 1000);
                }
            };
        }
    }
    __get_all_orders_infor();
    render_my_restaurant();
})

window.__get_all_orders_infor = function(){

    if (!user_login) return
    __checkout_load.get_orders = false
    $("#shopping_cart_btn").removeClass("go_open_order");
    $.ajax({
      url: "/getUserOrders",
      type: "GET",
      contentType: 'application/json',
      dataType: 'json'
    })
    .done((res)=>{
        __all_orders_information = _.orderBy(res,["last_active"],["desc"]);
        modal_all_orders_infor();
        renderListMyOrder();
        $('.open-current-order').on('click',function(){
          $('#modal-all-order-infor').modal('hide');
          __checkout_my_order();
        })
      })
    .fail(()=>{
        return false;
    })
    .always(()=>{
        __checkout_load.get_orders = true
    })
}

function renderListMyOrder(){
    if(!_.size(__all_orders_information)){
        return;
    }

    let venue_id = $('#venueId').val();
    if(venue_id){
        let current_res = [];
        if(venue_id){
            current_res = _.filter(__all_orders_information, (item)=>{
                return item.venue_id == venue_id;
            })
        }

        let orders_paid = []
        let orders_unpaid = []
         _.forEach(current_res, (item)=>{
            if((item.payment_status == 'paid' || (item.order_type == 'only_rate' && item.state != 'in-cart')) && !item.modify ){
                orders_paid.push(item)
            }else{
                orders_unpaid.push(item)
            }
        })

        let html = `
            <div id="modal-all-my-order" class="modal fade" role="dialog">
                <div class="modal-dialog">

                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2 class="modal-title">List of your orders</h2>
                        </div>
                        <div class="modal-body">
                            <div class="h4 title-body">OPEN ORDERS</div>
                            <ul class="list-group">
                                ${render_orders_infor(orders_unpaid) || '<div style="color: grey; font-style: italic">There are no orders in this category right now</div>'}
                            </ul>
                            <div class="h4 title-body" style="margin-top: 20px;">PLEASE RATE</div>
                            <ul class="list-group">
                                ${render_orders_infor(orders_paid) || '<div style="color: grey; font-style: italic">There are no orders in this category right now</div>'}
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        </div>
                    </div>

                </div>
            </div>
        `;
        $('.show-modal-my-orders').html(html);
        $('.show-modal-incart-order').click(function(e){
            $('#modal-all-my-order').modal('hide');
            $('#collapseMyOrder').modal('show');
        });
    }

    function render_orders_infor(infor){
        let html = ``;
        let in_process = 0;

        _.forEach(infor, (item)=>{
        let order_type = '';
        if(item.order_type == 'pickup') order_type = 'Pickup';
        if(item.order_type == 'delivery') order_type = 'Delivery';
        if(item.order_type == 'order-ahead') order_type = 'Order Ahead';
        let order_total = 0;
        if(item.order_type == 'only_rate'){
            order_total = '<i>Rate</i>'
        }else{
            order_total = calculate_total_price(item);
        }
        // check paid
        let isPaid = false;
        if(item.state == 'approved' || item.order_type == 'only_rate'){
          isPaid = true;
          in_process ++
        }

        html += `
            <li class="item-order">
                ${venue_id != item.venue_id ?
                `<a href="${item.state == 'approved' || item.order_type == 'only_rate' ? '/rate/order/'+item.order_id : 'javascript: void(0)'}" class="go_open_order" data-orderid="${item.order_id}" data-venueid="${item.venue_slug ? item.venue_slug : item.venue_id}">`
                : `<a href="${item.state == 'approved' || item.order_type == 'only_rate' ? '/rate/order/'+item.order_id : 'javascript: void(0)'}" class="open-current-order">`}
                    <div class="item-order-svg">
                        ${ item.order_type == 'pickup' ? `
                            <svg width="1.5em" height="1.5em" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #666;">
                                <path d="M1.69629 6.19141L10.4828 6.10352C10.4828 6.10352 10.5586 6.10352 10.5586 6.18084L11.3931 15.3045C11.3931 15.3045 11.3931 15.3819 11.3172 15.3819H1.07586C1 15.3819 1 15.3819 1 15.3045L1.69629 6.19141Z" stroke="#4C4C4C" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M4.11054 2.08301H3.2002V6.02631H4.11054V2.08301Z" stroke="#4C4C4C" stroke-width="0.75" stroke-miterlimit="10"/>
                                <path d="M9.11738 2.2373H8.20703V6.02596H9.11738V2.2373Z" stroke="#4C4C4C" stroke-width="0.75" stroke-miterlimit="10"/>
                                <path d="M3.2002 1.92784L4.11054 1H8.20709L9.11744 1.92784H3.2002Z" stroke="#4C4C4C" stroke-width="0.75" stroke-miterlimit="10" stroke-linejoin="round"/>
                            </svg>
                        ` : item.order_type == 'delivery' ? `
                            <svg width="1.5em" height="1.5em" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"  style="color: #666;">
                                <line x1="1.52109" y1="1.24453" x2="11.7365" y2="1.24453" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                <line x1="11.7672" y1="1.51719" x2="11.7672" y2="6.39187" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                <line x1="11.7672" y1="6.39199" x2="16.3577" y2="6.39199" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                <line x1="1.64219" y1="12.3012" x2="17.4825" y2="12.3012" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                <line x1="17.3922" y1="7.42637" x2="17.3922" y2="12.3011" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M15.2328 12.2278C15.2328 12.9455 14.6851 13.4833 14.0625 13.4833C13.4399 13.4833 12.8922 12.9455 12.8922 12.2278C12.8922 11.5101 13.4399 10.9723 14.0625 10.9723C14.6851 10.9723 15.2328 11.5101 15.2328 12.2278Z" fill="white" stroke="#4C4C4C" stroke-width="1.03437"/>
                                <path d="M6.23276 12.2278C6.23276 12.9455 5.68508 13.4833 5.06247 13.4833C4.43986 13.4833 3.89219 12.9455 3.89219 12.2278C3.89219 11.5101 4.43986 10.9723 5.06247 10.9723C5.68508 10.9723 6.23276 11.5101 6.23276 12.2278Z" fill="white" stroke="#4C4C4C" stroke-width="1.03437"/>
                                <line x1="0.517187" y1="4.02871" x2="6.23271" y2="4.02871" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                <line x1="0.517187" y1="6.39199" x2="5.10772" y2="6.39199" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                <line x1="1.64219" y1="8.75527" x2="3.98276" y2="8.75527" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                <path d="M16.3115 6.31836L17.4365 7.50017" stroke="#4C4C4C" stroke-width="1.03437"/>
                                <path d="M12.375 2.77246H14.0625" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                <path d="M14.0625 2.77246L16.3125 6.3179" stroke="#4C4C4C" stroke-width="1.03437"/>
                            </svg>
                        ` : item.order_type == 'order-ahead' ? `
                            <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-shop" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style="color: #666;">
                                <path fill-rule="evenodd" d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z"></path>
                            </svg>
                        ` : item.order_type == 'only_rate' ? `
                            <svg width="1.5em" height="1.5em" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #666;">
                                <path d="M5.60251 3.53174L5.95134 4.27455L6.27202 4.95742L7.01779 5.07131L7.9384 5.2119L7.22602 5.94168L6.72733 6.45256L6.84232 7.15716L6.9955 8.09583L6.28635 7.70401L5.60251 7.32618L4.91868 7.70401L4.20952 8.09583L4.36271 7.15716L4.4777 6.45256L3.97901 5.94168L3.26663 5.2119L4.18723 5.07131L4.93301 4.95742L5.25369 4.27455L5.60251 3.53174Z" stroke="#F3A446" stroke-width="2.82804"/>
                                <path d="M5.60251 3.53174L5.95134 4.27455L6.27202 4.95742L7.01779 5.07131L7.9384 5.2119L7.22602 5.94168L6.72733 6.45256L6.84232 7.15716L6.9955 8.09583L6.28635 7.70401L5.60251 7.32618L4.91868 7.70401L4.20952 8.09583L4.36271 7.15716L4.4777 6.45256L3.97901 5.94168L3.26663 5.2119L4.18723 5.07131L4.93301 4.95742L5.25369 4.27455L5.60251 3.53174Z" fill="#F3A446" stroke="#F3A446" stroke-width="2.82804"/>
                            </svg>
                        ` : item.order_type == 'waitlist' ? `
                    `: ``}
                    </div>
                    <div style="margin-left: 20px;float: left;">
                        <h5 style="margin: 0px;font-weight: 500;"> My Order ${isPaid ? in_process : ''}</h5>
                        <span style="color: #727272;">${order_type}</span>
                    </div>
                    <span class="badge float-right" style="font-size: 17px;margin-top: 11px;color: black">
                        <i class="fa fa-usd" aria-hidden="true"></i> ${order_total}
                    </span>
                </a>
            </li>`
        });
        return html;
    }
}

function render_my_restaurant(){

    let arrRestaurants =[];
    let userPermissions = $("#userPermissions").val();
    let arrRestaurantsSaleperson =[];
    var pageurl='';
    pageurl=$("#home").val();
    var  classval="";
    if(pageurl=='home'){
            var style="top:-14px;color:white"
            classval="white"
         }else{
            var style="top:-19px;"
            classval="";
         }
    $.ajax({
        url: '/restaurantadmin/listMyRestaurant',
        method: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: function (restaurants) {
            arrRestaurants = restaurants;
            __checkout_load.render_checkout = true;
            let count_Restautrent = arrRestaurants.length + arrRestaurantsSaleperson.length;

     let html_restaurant = ``;
        if(arrRestaurants && arrRestaurants.length >= 1) {


         if(!$('#show-list-restaurant').length){
            $('#show-rewards').replaceWith(`<div class="mobile-bottom-nav__item" style="width:20%" id="show-list-restaurant">
            <a href="javascript: void(0)" style=" color: #4a4a4a;"
              data-toggle="modal" data-target="#modal-restaurent">
              <div class="mobile-bottom-nav__item-content">
                <div class="top_item_nav">
                  <span class=" restaurant_card_badge count_Restautrent"></span>
                </div>
                <img src="/images/restaurant.png" class="ml-4" alt=""
                  style="width:20px;" />

                <span class="mobile_restaurant">Restaurant</span>
              </div>
            </a>
          </div>`);
         }
         

         $(".count_Restautrent").html(`${count_Restautrent}`);
          $('.orderRestaurent').html(`
          <span class="scard fix-margin-icon margin-header-icons pl-0 pl-md-2 " style="margin-top: 16px !important;">
              <a href="javascript: void(0)" style=" color: #4a4a4a;" data-toggle="modal" data-target="#modal-restaurent">

              <i class="fas fa-store-alt ${classval}" style="margin-left:-18px; font-size:18px;margin-top: 7px;"></i>

                <span class="restaurant_card_badge mobile-store-icon text-center" style=${style}>${count_Restautrent ? count_Restautrent :''}</span>
                <span class="mobile_restaurant ml-1 mt-1" style="color: #4a4a4a;margin-left:-10px !important"> Restaurant</span>
              </a>
          </span>
          `);
          _.forEach(arrRestaurants, (item)=>{
              let roles = '';
              if(item.contracts && item.contracts._id){
                  roles = "<b>Administrator</b>, ";
              }
              if(item.leadsalesperson){
                  roles += "<i style='white-space: pre;'>Lead Salesperson</i>, ";
              }
              if(item.salesperson){
                  roles += "<i>Salesperson</i>, ";
              }
              if(item.isServer){
                  roles += "Server, ";
              }
              if(item.isDelivery){
                  roles += "Delivery, ";
              }
              if(item.isGreeter){
                  roles += "Greeter, ";
              }
              roles = roles.substring(0, roles.length-2)
              html_restaurant += `
                  <tr role="row" class="odd">
                          <td class="sorting_1">
                              <a href="javascript: void(0)" data-roles="${roles && roles=='<b>Administrator</b>'? 'Administrator': roles}" data-id="${item && item.slug  ? item.slug :item.venueId}" class="go_restaurant" class="go_restaurant green" style="font-weight: 600;">${ item.venue && item.venue.name ? item.venue.name :''}</a>
                          </td>
                          <td>${item.venue && item.venue.location.address ? item.venue.location.address :''}</td>
                          <td>${roles}</td>
                          <td style="text-align: center;">
                              <a href="javascript: void(0)" data-roles="${roles && roles=='<b>Administrator</b>'? 'Administrator': roles}" data-id="${item && item.slug && item.slug != '' ? item.slug :item.venueId}" class="go_restaurant btn btn-warning" style="font-size: 11px">View</a>
                          </td>
                      </tr>
                  `;
          })

          let html = `
          <div id="modal-restaurent" class="modal fade" role="dialog">
              <div class="modal-dialog">
              <!-- Modal content-->
              <div class="modal-content">
                  <div class="modal-header">
                      <h2 class="modal-title">Venues</h2>
                      <button class="close" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true" data-dismiss="modal"></i></button>
                  </div>
                  <div class="modal-body">
                      <div class="dataTables_scroll">
                          <div class="dataTables_scrollBody" style="position: relative; overflow: auto; width: 100%;">
                              <table id="myRestaurantTable_model" class="table dataTable no-footer" style="width: 100%;" role="grid" aria-describedby="myRestaurantTable_info">
                                  <thead>
                                      <tr role="row">
                                          <th class="sorting_asc" tabindex="0" aria-controls="myRestaurantTable_model" rowspan="1" colspan="1" style="width: 109px;" aria-sort="ascending" aria-label="Restaurant: activate to sort column descending">Restaurant</th>
                                          <th class="sorting" tabindex="0" aria-controls="myRestaurantTable_model" rowspan="1" colspan="1" style="width: 341px;" aria-label="Address: activate to sort column ascending">Address</th>
                                          <th class="sorting" tabindex="0" aria-controls="myRestaurantTable_model" rowspan="1" colspan="1" style="width: 33px;" aria-label="Role: activate to sort column ascending">Role</th>
                                          <th class="text-center sorting_disabled" rowspan="1" colspan="1" style="width: 35px;" aria-label="View">View</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      ${html_restaurant}
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                  </div>
              </div>
              </div>
          </div>
      `;
      $('.show-modal-restaurant').html(html);
      $('#myRestaurantTable_model').DataTable();
      }else{
        $('.orderRestaurent').html(`
          <span class="scard fix-margin-icon margin-header-icons pl-0 pl-md-2 " style="margin-top: 16px !important;">
              <a href="javascript: void(0)" style=" color: #4a4a4a;" data-toggle="modal" data-target="#modal-restaurent">
                <i class="fas fa-store-alt ${classval} ${userPermissions!='undefined' && userPermissions && (userPermissions.includes("PlateRate Admin") || userPermissions.includes("Salesperson") || userPermissions.includes("Restaurant Admin"))? '': 'hide'}" style="margin-left:-7px; font-size:18px;margin-top: 7px;"></i>

                <span class="restaurant_card_badge mobile-store-icon text-center" style=${style}>${count_Restautrent ? count_Restautrent :''}</span>
                <span class="mobile_restaurant ml-1 mt-1" style="color: #4a4a4a;margin-left:-10px !important"> Restaurant</span>
              </a>
          </span>
          `);
      }
      $(document).on('click','.go_restaurant', function(e){
          let $this = $(this);
          let roles = $this.data("roles");
          let venueId = $this.data("id");
          let venueSlug = $this.data("slug");
          let newUrl = `/restaurant/${venueSlug && venueSlug!='undefined'? venueSlug: venueId}`;
          if(roles && (roles.includes("Greeter") || roles.includes("Delivery") || roles.includes("Server") || roles.includes("Administrator"))){
            newUrl = `/restaurant/${venueSlug && venueSlug!='undefined'? venueSlug: venueId}#collapseRestaurantOrder`;
          }
          console.log("on click of go_restaurant...redirecting to..", newUrl);
          window.location.replace(newUrl)
          sessionStorage.setItem('scroll_order_restaurant', true);
      });
      }, //getting listMyRestaurant
      error: function (err) {},
  });
}
function mobileAndTabletcheck() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
function calculate_total_price(infor){
    let total_price = 0;
    if(infor.order_type == 'order-ahead'){
        total_price = _.toNumber(infor.restaurant_ff) + _.toNumber(infor.platerate_ff) + _.toNumber(infor.paypal)
    }else{
        total_price = _.toNumber(infor.restaurant_free_food) + _.toNumber(infor.platerate_free_food) + _.toNumber(infor.total_price)
    }
    return parseFloat(total_price).toFixed(2);
}

function modal_all_orders_infor(){
//return;
    let venue_id = $('#venueId').val();
    let current_res = [];
    if(venue_id){
        current_res = _.filter(__all_orders_information, (item)=>{
            return item.venue_id == venue_id;
        })
    }
    let all_orders_need_to_rate = _.filter(__all_orders_information, (item)=>{
        return item.payment_status == "paid" || item.order_type == 'only_rate';
    })
    if(all_orders_need_to_rate.length){
        $(".order-list-badge").text(all_orders_need_to_rate.length);
    }
    function render_orders_infor(infor,status){
        let html = ``;
        _.forEach(__all_orders_information, item => {
            if(item.order_type == 'only_rate'){
                infor.push(item);
            }
        })
        let orderItem = infor.map(item=>{
   
            return item;
        });
        openCart(infor, status)

        if(orderItem.length > 0){
            $.ajax({
            type: 'POST',
            url: `/rating/checkorder`,
            contentType: 'application/json',
            data: JSON.stringify({orderItem}),
            dataType: 'json',
            async: false,
            success: function(res){
                _.forEach(res.data, (item, index)=>{
                    let order_type = '';
                    if(item.order_type == 'pickup') order_type = 'Pickup';
                    if(item.order_type == 'delivery') order_type = 'Delivery';
                    if(item.order_type == 'order-ahead') order_type = 'Order Ahead';
                    let order_total = 0;
                    if(item.order_type == 'only_rate'){
                        order_total = '<i>Rate</i>'
                    }else{
                        order_total = calculate_total_price(item);
                    }

                    let href;
                    if ( status == 'paid' ){
                      href = '/rate/order/'+item.order_id;
                      if (item.order_type == 'order-ahead' && !item.stateOrder) {
                        href += '/menu-items';
                      }
                      if (item.stateOrder) href += '/menu-items'
                      else if (item.order_type == 'order-ahead')href += '/menu-items';
                    } else {
                       
                            href = 'javascript: void(0)';
                        
                    }
                    html += `
                        <li class="item-order rating-item-order" style="${index<=9?'':'display:none;'}">
                            ${venue_id != item.venue_id ?
                            `<a href="${href}" class="go_open_order" data-orderid="${item.order_id}" data-venueid="${item.venue_slug ? item.venue_slug : item.venue_id}">`
                            : `<a href="${href}" class="open-current-order">`}
                                <div class="item-order-svg">
                                    ${ item.order_type == 'pickup' ? `
                                        <svg width="1.5em" height="1.5em" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #666;">
                                            <path d="M1.69629 6.19141L10.4828 6.10352C10.4828 6.10352 10.5586 6.10352 10.5586 6.18084L11.3931 15.3045C11.3931 15.3045 11.3931 15.3819 11.3172 15.3819H1.07586C1 15.3819 1 15.3819 1 15.3045L1.69629 6.19141Z" stroke="#4C4C4C" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M4.11054 2.08301H3.2002V6.02631H4.11054V2.08301Z" stroke="#4C4C4C" stroke-width="0.75" stroke-miterlimit="10"/>
                                            <path d="M9.11738 2.2373H8.20703V6.02596H9.11738V2.2373Z" stroke="#4C4C4C" stroke-width="0.75" stroke-miterlimit="10"/>
                                            <path d="M3.2002 1.92784L4.11054 1H8.20709L9.11744 1.92784H3.2002Z" stroke="#4C4C4C" stroke-width="0.75" stroke-miterlimit="10" stroke-linejoin="round"/>
                                        </svg>
                                    ` : item.order_type == 'delivery' ? `
                                        <svg width="1.5em" height="1.5em" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"  style="color: #666;">
                                            <line x1="1.52109" y1="1.24453" x2="11.7365" y2="1.24453" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                            <line x1="11.7672" y1="1.51719" x2="11.7672" y2="6.39187" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                            <line x1="11.7672" y1="6.39199" x2="16.3577" y2="6.39199" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                            <line x1="1.64219" y1="12.3012" x2="17.4825" y2="12.3012" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                            <line x1="17.3922" y1="7.42637" x2="17.3922" y2="12.3011" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M15.2328 12.2278C15.2328 12.9455 14.6851 13.4833 14.0625 13.4833C13.4399 13.4833 12.8922 12.9455 12.8922 12.2278C12.8922 11.5101 13.4399 10.9723 14.0625 10.9723C14.6851 10.9723 15.2328 11.5101 15.2328 12.2278Z" fill="white" stroke="#4C4C4C" stroke-width="1.03437"/>
                                            <path d="M6.23276 12.2278C6.23276 12.9455 5.68508 13.4833 5.06247 13.4833C4.43986 13.4833 3.89219 12.9455 3.89219 12.2278C3.89219 11.5101 4.43986 10.9723 5.06247 10.9723C5.68508 10.9723 6.23276 11.5101 6.23276 12.2278Z" fill="white" stroke="#4C4C4C" stroke-width="1.03437"/>
                                            <line x1="0.517187" y1="4.02871" x2="6.23271" y2="4.02871" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                            <line x1="0.517187" y1="6.39199" x2="5.10772" y2="6.39199" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                            <line x1="1.64219" y1="8.75527" x2="3.98276" y2="8.75527" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                            <path d="M16.3115 6.31836L17.4365 7.50017" stroke="#4C4C4C" stroke-width="1.03437"/>
                                            <path d="M12.375 2.77246H14.0625" stroke="#4C4C4C" stroke-width="1.03437" stroke-linecap="round"/>
                                            <path d="M14.0625 2.77246L16.3125 6.3179" stroke="#4C4C4C" stroke-width="1.03437"/>
                                        </svg>
                                    ` : item.order_type == 'order-ahead' ? `
                                        <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-shop" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style="color: #666;">
                                            <path fill-rule="evenodd" d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z"></path>
                                        </svg>
                                    ` : item.order_type == 'only_rate' ? `
                                        <svg width="1.5em" height="1.5em" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #666;">
                                            <path d="M5.60251 3.53174L5.95134 4.27455L6.27202 4.95742L7.01779 5.07131L7.9384 5.2119L7.22602 5.94168L6.72733 6.45256L6.84232 7.15716L6.9955 8.09583L6.28635 7.70401L5.60251 7.32618L4.91868 7.70401L4.20952 8.09583L4.36271 7.15716L4.4777 6.45256L3.97901 5.94168L3.26663 5.2119L4.18723 5.07131L4.93301 4.95742L5.25369 4.27455L5.60251 3.53174Z" stroke="#F3A446" stroke-width="2.82804"/>
                                            <path d="M5.60251 3.53174L5.95134 4.27455L6.27202 4.95742L7.01779 5.07131L7.9384 5.2119L7.22602 5.94168L6.72733 6.45256L6.84232 7.15716L6.9955 8.09583L6.28635 7.70401L5.60251 7.32618L4.91868 7.70401L4.20952 8.09583L4.36271 7.15716L4.4777 6.45256L3.97901 5.94168L3.26663 5.2119L4.18723 5.07131L4.93301 4.95742L5.25369 4.27455L5.60251 3.53174Z" fill="#F3A446" stroke="#F3A446" stroke-width="2.82804"/>
                                        </svg>
                                    ` : item.order_type == 'waitlist' ? `
                                `: ``}
                                </div>
                                <div style="margin-left: 20px;float: left;">
                                    <h5 style="margin: 0px;font-weight: 500;">${item.venue_name}</h5>
                                    <span style="color: #727272;">${order_type}</span>
                                </div>
                                <span class="badge float-right" style="font-size: 17px;margin-top: 11px;color: black">
                                    <i class="fa fa-usd" aria-hidden="true"></i> ${order_total}
                                </span>
                            </a>
                        </li>`
                    });
            },
            error: function(err){
                console.log(err);
            }
        })
       }
         return html;
     }
    // function for  load more functionality of rating orders
     $("body").on('click', '#rating-load-more', function (e) {
         e.preventDefault();
         $("html,body, .rating-item-order:hidden").slice(0, 10).slideDown();
         if ($(".rating-item-order:hidden").length == 0) {
             $("#rating-load-more").css('visibility', 'hidden');
         }
         
         $('#modal-all-order-infor').animate({
             scrollTop: $(this).offset().top
         }, 1000);
     });
    let url = new URL(window.location.href);
    let rateOnlyId = url && url.searchParams ? url.searchParams.get('rateOnlyId') : '';
    if(rateOnlyId) $('html, body').animate({ scrollTop: $(`#btn-add-menu-item`).offset().top - 200 }, 800);
    let orders_paid = []
    let orders_unpaid = []
    let rateOnlyModify = false;
    _.forEach(__all_orders_information, (item)=>{
        if (item.order_id == rateOnlyId){
          orders_unpaid[0] = item;
        }else if((item.payment_status == 'paid' || (item.order_type == 'only_rate' && item.state != 'in-cart')) && !item.modify){
            orders_paid.push(item)
        }else{
            orders_unpaid.push(item)
        }
    })
    let order_unpaid_infor  = _.find(orders_unpaid, elem => elem.venue_id == venue_id);
    let oldSlugs = order_unpaid_infor && order_unpaid_infor.old_slugs? order_unpaid_infor.old_slugs: [];
    let found = false;
    if(oldSlugs && oldSlugs.length>0){
        found = oldSlugs.some(slug => current_urlval.includes(slug));
    }
    if(orders_unpaid.length >0 && order_unpaid_infor){
      let order_total = calculate_total_item(order_unpaid_infor);
      $(".shopping_card").addClass('green');
      $(".scard").find('.badge').addClass("shopping_card_badge");
      $('#cartSvg').attr("src", "/images/logocartgreen.png")
      $("#cartText").addClass("green");
      $(".shopping_card_badge").html(`${order_total}`);
      if(order_unpaid_infor && _.includes(current_urlval, order_unpaid_infor.venue_slug) == false && _.includes(current_urlval, order_unpaid_infor.venue_id) == false) {
        //   $(".shopping_cart_btn").addClass("go_open_order");
          $(".shopping_cart_btn").attr("data-orderid",order_unpaid_infor.order_id);
          $(".shopping_cart_btn").attr("data-venueid",order_unpaid_infor.venue_slug ? order_unpaid_infor.venue_slug : order_unpaid_infor.venue_id);
      }else{
        // $(".shopping_cart_btn").removeClass("go_open_order");
        $(".shopping_cart_btn").removeAttr("data-orderid");
        $(".shopping_cart_btn").removeAttr("data-venueid");
          
      }
    } else if(orders_unpaid.length >0) {
        let order_total = calculate_total_item(orders_unpaid[0]);
        console.log("order_total========",order_total)
        $(".shopping_card").addClass('green');
        $(".scard").find('.badge').addClass("shopping_card_badge");
        $('#cartSvg').attr("src", "/images/logocartgreen.png")
        $("#cartText").addClass("green");
        $(".shopping_card_badge").html(`${order_total}`);
        if(orders_unpaid.length === 1){
            $(".shopping_card_badge").html(`${order_total}`);
        }
        else if(order_unpaid_infor && _.includes(current_urlval, order_unpaid_infor.venue_slug) == false && _.includes(current_urlval, order_unpaid_infor.venue_id) == false) {
            $(".shopping_card_badge").html(`${order_total}`);
        }
        else{
           $(".shopping_card_badge").html(`${orders_unpaid.length}`);
        }
        if(_.includes(current_urlval, orders_unpaid[0].venue_slug) == false && _.includes(current_urlval, orders_unpaid[0].venue_id) == false) {
            // $(".shopping_cart_btn").addClass("go_open_order");
            $(".shopping_cart_btn").attr("data-orderid",orders_unpaid[0].order_id);
            $(".shopping_cart_btn").attr("data-venueid",orders_unpaid[0].venue_slug ? orders_unpaid[0].venue_slug : orders_unpaid[0].venue_id);
        }
    }else {
        $("#shopping_cart_btn").removeClass("go_open_order");
        $(".shopping_card").removeClass('green');
        $(".scard").find('.badge').removeClass("shopping_card_badge");
        $(".scard").find('.badge').html("");
    }

    let htmlOpenOrder = `
    <div id="openOrder" class="modal fade" role="dialog">
        <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title">List of your orders</h2>
                    <button class="close closemodel" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true" data-dismiss="modal"></i></button>
                </div>
                <div class="modal-body">
                    <div class="h4 title-body">OPEN ORDERS</div>
                    <ul class="list-group">
                        ${render_orders_infor(orders_unpaid, "unpaid" ) || '<div style="color: grey; font-style: italic">There are no orders in this category right now</div>'}
                    </ul>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default closemodel" data-dismiss="modal">Close</button>
                </div>
            </div>

        </div>
    </div>
`;


    let html = `
    <div id="modal-all-order-infor" class="modal fade" role="dialog" style="z-index: 1080;">
        <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title">List of your orders</h2>
                    <button class="close" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true" data-dismiss="modal"></i></button>
                </div>
                <div class="modal-body">
                    <div class="h4 title-body" style="margin-top: 20px;">PLEASE RATE</div>
                    <ul class="list-group">
                        ${render_orders_infor(orders_paid, 'paid') || '<div style="color: grey; font-style: italic">There are no orders in this category right now</div>'}
                    </ul>
                    <div class="text-center">
                        <a href="" id="rating-load-more" class="load-more">Load More</a>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>

        </div>
    </div>
`;
    $('.show-modal-all-orders').html(html);
    
    if(!order_unpaid_infor && orders_unpaid.length === 1){
       $('.show-modal-openOrder').html(htmlOpenOrder).hide();
    }
    
    
    $(document).on('click', '.closemodel', function () {
       $('#openOrder').modal('hide')
    })
    
$(document).on("click",".go_open_order",function(e) {
        let $this = $(this);
        let venueId = $this.data("venueid");
        let orderId = $this.data("orderid");
        /****Commented by Amit for checking stoped fuctionality*****/
        if(typeof(orderId)!='undefined' && typeof(venueId)!='undefined'){
          let newUrl = `/restaurant/${venueId}`;
          sessionStorage.setItem('scroll_order_id', orderId);
          console.log("on click of go_open_order...redirecting to..", newUrl);
          window.location.href = newUrl;
        }
        __checkout_my_order();
    });

    $(".shopping_cart_btn").on("click",function(){ 
        console.log("shopping_cart_btn clicked");
        if(!$(this).hasClass("go_open_order")){ __checkout_my_order(); }
        if(!order_unpaid_infor ){
            $('#myorder-accordion').css('display','none');
        }
        else{
            $('.show-modal-openOrder').hide();
            $('#order-modal-dialog').css('display', 'block')
        }
        if(!order_unpaid_infor && orders_unpaid.length === 1){
            if(window.location.href.includes('/restaurant/')) {
                $('.show-modal-openOrder').html(htmlOpenOrder).show();
            } else {
                $('.show-modal-openOrder').html(htmlOpenOrder).hide();
                let newUrl = `/restaurant/${orders_unpaid[0].venue_slug}`;
                window.location.href = newUrl;
            }
        }else if(!order_unpaid_infor && orders_unpaid.length != 1){
           if(window.location.href.includes('/restaurant/')) {
               $('.show-modal-openOrder').html(htmlOpenOrder).show();
           } else {
               $('.show-modal-openOrder').html(htmlOpenOrder).hide();
               let newUrl = `/restaurant/${orders_unpaid[0].venue_slug}`;
               window.location.href = newUrl;
           }
        //    $('.show-modal-openOrder').html(htmlOpenOrder).hide();
        //    let newUrl = `/restaurant/${orders_unpaid[0].venue_slug}`;
        //     window.location.href = newUrl;
        }
        if(order_unpaid_infor && order_unpaid_infor.item_count > 0){
            $('.show-modal-openOrder').hide();
        }
    });

    if(firstLoadOrder && orders_unpaid.length > 0 && order_unpaid_infor){
        firstLoadOrder = false;
        __checkout_my_order();
    }

    function openCart(infor, status) {
        if (infor.length <= 1) {
            $('.show-modal-openOrder').hide()
        } else {
            $('.shopping_cart_btn').click(() => {
                if(!venue_id || venue_id && !($(".open-current-order").data("venueid") == venue_id)){
                    $('.show-modal-openOrder').html(htmlOpenOrder).show();
                }
                $('.go_open_order').click(function(e){
                    let $this = $(this);
                    let venueId = $this.data("venueid");
                    let orderId = $this.data("orderid");
                    if(typeof(orderId)!='undefined' && typeof(venueId)!='undefined'){
                      let newUrl = `/restaurant/${venueId}`;
                      sessionStorage.setItem('scroll_order_id', orderId);
                      console.log("on click of go_open_order...redirecting to..", newUrl);
                      window.location.href = newUrl;
                    }
                });
           })
        }
        // if (status === "unpaid") {
        //     $("#count_val").hide()
        // }
    }
}

function calculate_total_item(infor){
  return infor && infor.item_count ? infor.item_count :'';
}
function render_pagination(element, data, amount, callback){
    let total = _.size(data)
    data = _.chunk(data, amount)
    let page = ''
    _.forEach(data, (item, index) => {
        page += `
            <li class="page-item">
                <a class="page-link" href="#" data-page="${index}" style="border: none !important;">${index + 1}</a>
            </li>
        `
    })
    let html = `
    <div class="d-flex justify-content-end align-items-center">
        <div class="mr-3" style="font-size: 15px;">
            Show <span class="show-per-total">${amount > total ? total : amount}</span> / ${total}
        </div>
        <nav aria-label="">
            <ul class="pagination pagination-sm justify-content-end mb-0">
                <li class="page-item">
                    <a class="page-link" href="#" data-page="previous" style="border: none !important;">
                        <i class="fa fa-chevron-left" aria-hidden="true" data-page="previous"></i>
                    </a>
                </li>
                ${ page }
                <li class="page-item">
                    <a class="page-link" href="#" data-page="next" style="border: none !important;">
                        <i class="fa fa-chevron-right" aria-hidden="true" data-page="next"></i>
                    </a>
                </li>
            </ul>
            <input type="hidden" class="current-page" value="0">
        </nav>
    </div>
    `;
    $(element).html(html)
    $(element).find('.page-link').on('click', function(e){
        $(element).find('.page-item').removeClass('active')
        let elem = $(e.target)
        let page_index = elem.data('page')

        let current_page = $(element).find('.current-page').val()
        current_page = _.toNumber(current_page)

        if(page_index == 'previous') {
            if(current_page - 1 >= 0) current_page--
        } else if(page_index == 'next') {
            if(current_page + 1 < _.size(data)) current_page++
        } else {
            current_page = _.toNumber(page_index)
        }
        $(element).find('.current-page').val(current_page)
        let el = $(element).find(`.page-link[data-page="${current_page}"]`)
        el.parent().addClass('active')
        $(element).find('.show-per-total').text(amount * (current_page+ 1))
        return callback(data[current_page])
    })
    return $(element).find('.page-link').eq(1).click()
}
window.__paginate = render_pagination

window.__checkout_my_order = function() {
    $('#myorder-accordion').css('display','block');
    $('#order-container').css('opacity','1');
    $('#order-container').css('pointer-events','auto');

    if($("#myorder-accordion").length){
    console.log("checking click or not..........");
        $("#collapseMyOrder").modal({
            backdrop: 'static',
            keyboard: true
        });
        haveBackdrop()
    }
}

    // If user access invite link order-ahead
    let url = new URL(window.location.href);
    let hostId_orderAhead = url.searchParams.get('order_id');
    let userEmail = url.searchParams.get('email');
    if(hostId_orderAhead && userEmail){
      let infor = {
        order_id: hostId_orderAhead,
        email: userEmail
      }
      sessionStorage.order_ahead_invitation = JSON.stringify(infor)
      console.log("not logged in, will redirect to login.");
      if(!$('userId').val()) window.location.href = `/users/login?next=/restaurant/${$('#venueId').val()}`
    }

function getDisplayName(firstname,lastname){
    let lastnameval=''
    if(lastname!=null && lastname.trim().length>0){
     lastnameval = lastname.trim().substring(0,1).toUpperCase()+'.';
    }
    let firstnameval=''
    if(firstname!=null && firstname.trim().length>0){
     firstnameval = firstname.trim().substring(0,1).toUpperCase();
     if(firstname.length>1){
        firstnameval=firstnameval+firstname.substring(1).toLowerCase();
     }
    }
    return (firstnameval+' '+lastnameval).trim();

}

/**
 * Calculates distance between to geo locations lat and lng
 * with Haversine algorithm
 * The distance returned is aprox. accurate
 * http://www.movable-type.co.uk/scripts/latlong.html
 * @param {Number} userLat
 * @param {Number} userLng
 * @param {Number} venueLat
 * @param {Number} venueLng
 */
window._calculateDistance = function(userLat, userLng, venueLat, venueLng) {
  if (!userLat || !userLng || !venueLat || !venueLng) return null;

  function toRad(x) {
    return x * Math.PI / 180;
  }

  const lat1 = userLat;
  const lat2 = venueLat;
  const lon1 = userLng;
  const lon2 = venueLng;

  const R = 3958; //6371 km //3958 //mi  //
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;

  return parseFloat(distance.toFixed(1));
}

function toggleDietPref(e){
	let itemId  = $(e).data('item-id');
	let state = $(e).children().first().text();
	let display = state == "Hide" ? "display : none !important;" : "display : block !important";
	if(state=='Hide'){
		$(e).children().first().text('Dietary Preferences?');
		$('.d-pref-seprator_line_'+itemId).css('display','none');
        $('.collapse-menu-item-'+itemId).css('display','none');
        $('#favorites-expert-review-of-'+itemId).css('display','none');
        $('#menu-expert-review-of-'+itemId).css('display','none');
		$('.menu-card-add-btn_'+itemId).css('width','100%');
	}else{
		$(e).children().first().text('Hide');
		$('.d-pref-seprator_line_'+itemId).css('display','block');
		$('.menu-card-add-btn_'+itemId).css('width','auto');
        $('.collapse-menu-item-'+itemId).css('display','');
        $('#favorites-expert-review-of-'+itemId).css('display','');
        $('#menu-expert-review-of-'+itemId).css('display','');
	}
	$('.target-diet-pref-toggle_'+itemId).attr("style", display);

}


//
window.getIndicatorClass = function(ref, _current, _min, _max, totalLength) {
  if (ref == _current) {
    return 'active';
  }
  if (totalLength <= 5) return 'std';
  if (ref >= _min && ref <= _max) return 'std';
  if (ref == _min - 1 || ref == _max + 1) return 'small';
  if (ref == _min - 2 || ref == _max + 2) return 'micro';
  return 'hidden';
}

window.attachCarouselIndicators = function(selector) {
  // Add event listener
  $(document).on('slide.bs.carousel', selector, function (e) {
    const lastIndex = e.from;
    const current = e.to;
    const direction = current - lastIndex;
    const $target = $(e.currentTarget);
    const $indicatorWrapper = $target.find('.indicators-wrapper');
    if ($indicatorWrapper.length == 0) return;

    let _min = $indicatorWrapper.data('min');
    let _max = $indicatorWrapper.data('max');
    let MAX_VISIBLE_INDICATORS = $indicatorWrapper.data('max-visible');
    let $indicators = $indicatorWrapper.find('span');

    if (current > 3) {
      MAX_VISIBLE_INDICATORS = 2;
    } else if (current == 0){
      MAX_VISIBLE_INDICATORS = 3;
      _min = 0;
      _max = MAX_VISIBLE_INDICATORS;
    } else if (current == ($indicators.length - 1)){
      MAX_VISIBLE_INDICATORS = 3;
      _min = $indicators.length - MAX_VISIBLE_INDICATORS;
      _max = $indicators.length;
    }

    if (current < _min) {
      _min = current;
      _max = _min + MAX_VISIBLE_INDICATORS;
      if (_max > $indicators.length) {
        _max = $indicators.length;
      }
    }
    if (current > _max) {
      _max = current;
      _min = _max - MAX_VISIBLE_INDICATORS;
      if (_min < 0) {
        _min = 0;
      }
    }
    $indicatorWrapper.data('min', _min);
    $indicatorWrapper.data('max', _max);
    $indicatorWrapper.data('max-visible', MAX_VISIBLE_INDICATORS);

    $indicators.each((i, indicator) => {
      $(indicator).removeClass();
      $(indicator).addClass(getIndicatorClass(i, current, _min, _max, $indicators.length));
    });
  })

}
function updateLocation(){
    var data = {
        lat:Cookies.get('posLat'),
        lng:Cookies.get('posLon')
    };

    $.ajax({
        url: '/updateLocation',
        method: 'POST',
        dataType: 'json',
        data:data,
    });
}
//dont know why its calling 
//setInterval(updateLocation,60000);
